import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ColaOrdenesService } from '../../services/cola-ordenes.service';
import { OrigenOrden } from '../../shared/pipes/origen-orden.pipe';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CookieService } from 'ngx-cookie-service';
import { concat, EMPTY, Observable, Subscription, first, from, interval, lastValueFrom, of, timer } from 'rxjs';
import { catchError, concatMap, map, reduce, shareReplay, switchMap, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { BrokerOrder } from 'src/app/services/broker-adapter.interface';
import { MetaApiService, MetaApiDownloadFase, ACC_INFO_TTL_BROKER_MS } from 'src/app/services/meta-api.service';
import { Mt5GatewayService } from 'src/app/services/mt5-gateway.service';
import { MetaApiStreamingService } from 'src/app/services/metaapi-streaming.service';
import { MetaapiCandlesSyncService } from 'src/app/services/metaapi-candles-sync.service';
import { BrokerTimeService } from 'src/app/services/broker-time.service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { SseService } from 'src/app/services/SseService';
import { MatDialog } from '@angular/material/dialog';
import { ReconfiguracionDialogComponent } from '../reconfiguracion-dialog/reconfiguracion-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TemaService } from 'src/app/services/tema.services';
import { Broker, BrokerService } from 'src/app/services/broker.services';
import { BrokerOpDialogComponent } from './broker-op-dialog/broker-op-dialog.component';
import { RealTimeService } from 'src/app/services/realtime.service';
import { ibrkServices } from 'src/app/services/ibrk.service';
import { OrdenBrokerInterface } from 'src/app/interface/OrdenBrokerInterface';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { TradeBrokerInterface } from 'src/app/interface/TraderBrokerInterface';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { Notificacion } from 'src/app/models/notificacion';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { OAuthService } from 'src/app/services/oauth.service';
import { global } from 'src/app/global';
import { SuscripcionesConfirmarComponent } from './suscripciones-confirmar/suscripciones-confirmar.component';
import { WalletMetrics, walletMetricsKey } from 'src/app/shared/utils/wallet-metrics.util';
import { isooperDeOrderRef } from 'src/app/shared/utils/order-ref.util';
import { TablamercadoComponent } from '../tablamercado/tablamercado.component';
import { ToastrService } from "ngx-toastr";
import { CompaniaWebsocketService } from 'src/app/services/compania-websocket.service';
import { PosicionesService } from 'src/app/services/posiciones.service';
import { MarketDataService } from '../../services/market-data.service';
import { PositionsService } from 'src/app/services/Positions.service';
import { dataSeries } from '../charts/apexcharts/zoomable-line-chart/data-series';
import { DynamicDataSource } from '../ui-kit/tree/tree-with-dd/tree-with-dd.component';
import { periodoToTimeframe } from 'src/app/utils/periodo.util';
import { translateMetaApiError, translateMetaApiHttpError } from 'src/app/services/meta-api-error-messages';
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';
import { fechaHoyIso, fechaOperacionBackend, parseDateOrFallback } from 'src/app/shared/utils/date-utils';
import { SincronizarComparativaDialogComponent } from './sincronizar-comparativa-dialog/sincronizar-comparativa-dialog.component';
import { SalirFinDiaDialogComponent } from './salir-fin-dia-dialog/salir-fin-dia-dialog.component';
import { CarteraComponent } from '../cartera/cartera.component';
import { BrokerTabLockService } from 'src/app/services/broker-tab-lock.service';
import { SalidaOperacionBrokerService } from 'src/app/services/salida-operacion-broker.service';

/** Resultado de descargarCandlesMetaapi. */
interface ResultadoDescargaVelas {
  /** false si faltan credenciales o falló la descarga (en modo completa, cualquier par). */
  ok: boolean;
  /** Activos sin sus últimas barras: revisarModeloBrokerIajava no genera entradas para ellos. */
  idNectumSinVelas: number[];
  /** "ISO timeframe: motivo" de cada par bloqueado, para el aviso. */
  avisos: string[];
}

/** Clave de cada pestaña en `?tab=`; el índice coincide con el del mat-tab-group. */
const BROKER_TABS = ['contabilidad', 'operaciones', 'valores', 'rendimientos', 'posiciones', 'control'];
const TAB_CONTROL = 5;
/** Clave en `?paneles=` de cada panel plegable de Control Operativa. */
const PANELES_CONTROL = {
  pos: 'mostrarPosicionesControl',
  ord: 'mostrarOrdenesControl',
  mt: 'mostrarOperacionesMtControl',
} as const;
type PanelControl = keyof typeof PANELES_CONTROL;

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  styleUrl: './broker.component.scss'
})
export class BrokerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(TablamercadoComponent) tablaMercado: TablamercadoComponent;
  @ViewChild(CarteraComponent) carteraComponent: CarteraComponent;
  /** Toggle "Ordenes oco" de la pestaña Control Operativa (solo existe con esa pestaña abierta). */
  @ViewChild(SuscripcionesConfirmarComponent) suscripcionesConfirmar?: SuscripcionesConfirmarComponent;

  private stkcfdSubscription: Subscription;
  private isCalculating = false;
  private carterasmetaapi: any[] = [];
  /** Especificación MetaTrader por símbolo (en mayúsculas) de la cuenta specsMetaApiCuenta */
  private specsMetaApi = new Map<string, any>();
  private specsMetaApiPedidas = new Set<string>();
  private specsMetaApiCuenta = '';

  public apiIbkrAvailable: boolean = localStorage.getItem('apiIbkrAvailable') === 'false' ? false : true;
  private pendingCalls: Array<() => Promise<void>> = [];
  private retryInterval: any;
  public listaOrdenesBroker: any[] = [];
  contadortrades: number = 0;
  public selectedTab: number = 0;
  public loading: boolean = false;
  public isLoadingMetaapi: boolean = false;
  public candlesDownloadBatch: number = 0;
  public candlesDownloadTotal: number = 0;
  public candlesDownloadExpected: number = 0;
  public candlesDownloadSymbol: string = '';
  public candlesDownloadFase: MetaApiDownloadFase | '' = '';
  /** Día del broker (dd/MM/yyyy) de la última sincronización correcta de velas 1d. */
  private ultimoDiaSyncDiario: string | null = null;
  /** Día del broker de la última sincronización completa (huecos y cola antigua) tras una revisión. */
  private ultimoDiaSyncCompleta: string | null = null;
  /** Cancela la descarga `completa` en curso; la revisión de un cierre tiene prioridad. */
  private cancelarDescargaCompleta: (() => void) | null = null;
  /** Barras cerradas que deben estar descargadas para que el modelo pueda abrir en un activo. */
  private static readonly BARRAS_MINIMAS_REVISION = 200;
  /** Minutos de retraso del feed a partir de los cuales no se abren entradas (datos delayed del broker). */
  private static readonly RETRASO_MAX_MIN = 3;
  /** Un último precio más antiguo que esto es mercado cerrado o sin cotizar, no un feed retrasado. */
  private static readonly RETRASO_MERCADO_CERRADO_MIN = 60;
  /** idNectum del último mercado cuyas velas 1d se descargaron: valBrokCompania$ también emite con cada precio. */
  private claveMercadoDescargado = '';
  public stkcfd: string = 'STK';
  errString: string = '';

  disabledByAccount: boolean = false;
  /*   public listModelo: any; */
  /*   public mercados: any; */
  public estadoparaenviar = '';

  public intervalos: any;
  public modo: string = 'dev'; // Default to 'prod'
  public contadosultimoordenes = 0;
  public sumaprecioordees = 0;
  public listaMercado: boolean = localStorage.getItem('broker_panel_listaMercado') !== 'false';
  public cartera: boolean = localStorage.getItem('broker_panel_cartera') !== 'false';
  public texto: string = ">>"
  public mouseSobreDiv: boolean = false;
  public subBrokOptima: Subscription;
  public subBrokCompaniaMercado: Subscription;
  private subSincronizacionSolicitada?: Subscription;
  public subtema: Subscription;
  private subActualizar: Subscription;
  public isDark: boolean = false;
  public filaSeleccionada: any;
  efectivopositivo: boolean = true;
  public riesgomaximo: number = 0;
  public walletMetrics: WalletMetrics | null = null;
  efectivopositivobroker: boolean = true;
  public isGestion: boolean = false;
  public isBroker: boolean = true;
  private subOrdenes: Subscription;
  private metaApiOrdersTimeout: any = null;
  //private tickle: Subscription;// mantener sesion en broker
  //private operacionesPendientes: Subscription;
  private subTrades: Subscription;
  private subPositions: Subscription;
  private subRealTimeCartera: Subscription | null = null;
  private subCarteraStreamStatus: Subscription | null = null;
  private subCarteraRestFallback: Subscription | null = null;
  /** ISOs suscritos al socket para la cartera (mayúsculas, ordenados). */
  private carteraStreamKey = '';
  /** Último POST metaapi/tiemporeal por ISO (se limita a uno por minuto). */
  private readonly carteraUltimoPost = new Map<string, number>();
  private subRealTimeWs: Subscription | null = null;
  private subHistoryDeals: Subscription | null = null;
  /** Ventana de recuperación de cierres: 60 días. Antes era `60 * 24 * 60 * 1000`, que son
   *  24 horas y no 60 días, así que cualquier cierre perdido durante más de un día era
   *  irrecuperable. */
  private static readonly DEALS_VENTANA_AMPLIA_MS = 60 * 24 * 60 * 60 * 1000;
  /** Ventana del sondeo periódico (1 día): suficiente para no perder cierres entre vueltas. */
  private static readonly DEALS_VENTANA_SONDEO_MS = 24 * 60 * 60 * 1000;
  public licencia: string;
  public isOco: boolean = false;
  /** Secciones plegables de Control Operativa (como "Ver gráficas"). */
  public mostrarPosicionesControl = true;
  public mostrarOrdenesControl = false;
  public mostrarOperacionesMtControl = false;
  /** Alto (px) de los paneles de Control Operativa, ajustable arrastrando su divisor. */
  public altoPosicionesControl = BrokerComponent.leerAltoControl('controlOpAltoPosiciones');
  public altoOrdenesControl = BrokerComponent.leerAltoControl('controlOpAltoOrdenes');
  public altoOperacionesMtControl = BrokerComponent.leerAltoControl('controlOpAltoOperacionesMt');
  /** Propiedad de alto y clave de localStorage de cada panel redimensionable de Control Operativa. */
  static readonly PANELES_CONTROL = {
    posiciones: { prop: 'altoPosicionesControl', clave: 'controlOpAltoPosiciones' },
    ordenes: { prop: 'altoOrdenesControl', clave: 'controlOpAltoOrdenes' },
    operacionesMt: { prop: 'altoOperacionesMtControl', clave: 'controlOpAltoOperacionesMt' },
  } as const;
  private static readonly ALTO_CONTROL_DEFECTO = 220;
  private finResizeControl: (() => void) | null = null;
  public tradersActuales: TradeBrokerInterface[] = [];
  public operacionesActuales: operationinterface[] = [];
  public operacionesActualesSalida: operationinterface[] = [];
  private subscription: Subscription;
  public ordenesActuales: OrdenBrokerInterface[] = [];
  public url = '/iserver/auth/status';
  public textButton: string = '';
  public competingSessionWarned: boolean = false;
  public intervalSubscription: Subscription | undefined;
  private _isLoggin: boolean = false;
  public get isLoggin(): boolean { return this._isLoggin; }
  public set isLoggin(value: boolean) {
    this._isLoggin = value;
    const strVal = value ? 'true' : 'false';
    localStorage.setItem('brokerConectado', strVal);
    // Dispatch a storage event so the same window's header listener also reacts
    window.dispatchEvent(new StorageEvent('storage', { key: 'brokerConectado', newValue: strVal }));
  }
  setTimeoutId: any;
  public idCarteraActual: number = 0;
  public subCarteraActual: Subscription;
  public suscrito: boolean = false;
  private modeloRevisionTimerId: any;
  private modeloRevisionNextAt = 0;
  private periodoSuscripcionId: number = 0;
  private periodoSuscripcionIntervalSeconds: number = 32;
  private periodosCarteraActual: string[] = [];
  //public revisadosuscrito: boolean = false;
  public idcarterasuscrita: number = 0;
  public desdeDate: Date = new Date();
  private cuentaUrlParam: string = ''; // Para evitar apertura doble del diálogo
  private cuentaUrlProcesada: boolean = false; // Bandera para procesar cuenta de URL solo una vez
  private previousEstado: string = '';
  private previousColaLength: number = 0;
  public revisandomodeloia = false;
  /** Ya se avisó de que no se revisa el modelo por tener Algo Trading desactivado (se avisa una vez por apagado). */
  private avisadoAlgoTradingOff = false;
  public actualizandoTiempoReal = false;
  public actualizandoTiempoRealManual = false;
  /** Automatización activa: el modelo decide entradas y salidas; las acciones manuales quedan bloqueadas. */
  get automatizado(): boolean {
    return this._cookieService.check('auto' + this.BrokoptimalWallet?.idcartera);
  }
  accountType: string[] = [
    'MARGEN',
    'NOMINAL'
  ]

  purchaseTypes: string[] = [
    'LIMITADO',
    'FIJO'
  ]
  posicionesModel: operationinterface[];
  datawhatif: any[] = [];
  private idnectumsSubscription: Subscription;
  private mercadoIdnectumsArray: number[] = [];
  private idnectumsArray: number[] = [];
  contador: number = 0;
  lastBusinessDay: any;
  lastBusinessDayData: any;
  BrokoptimalWallet: OptimalWallet;
  brokerOffsetMin: number | null = null;
  brokerClockText: string = '';
  /** IBKR: zona IANA y exchange (iso) del mercado de origen de los activos de la cartera. */
  brokerClockZone: string | null = null;
  brokerClockLabel: string = '';
  private brokerClockZoneSeq = 0;
  private brokerClockInterval: any = null;
  datosmodelo: string = '';
  colaOrdenes: any[] = [];
  existemargenbroker: boolean = true;
  existemargen: boolean = true;
  mensageentradas: string = ''; //aqui se guarda el mensaje si no se puede hacer entradas
  brokerOpen: boolean = true;
  private verificandoHorarioCola = false;
  /** cOID de órdenes enviadas al broker y aún sin respuesta: la cola no las reenvía. */
  private envioEnCurso = new Set<string>();
  /** cOID de órdenes encoladas desde "Sincronizar comparativa": se envían aunque la automatización esté detenida. */
  private ordenesSincronizacion = new Set<string>();
  /** Si en este tiempo la orden encolada no llegó al broker, se anula (EXPIRADA-COLA). */
  private static readonly TTL_COLA_MS = 30 * 1000;
  /** Momento en que se encoló cada orden (fuera de ordersData para no alterar el payload al broker). */
  private encoladaEn = new WeakMap<object, number>();
  /** Qué disparó cada orden encolada (fuera de ordersData para no alterar el payload al broker). */
  private origenOrden = new WeakMap<object, OrigenOrden>();
  private subCancelarCola?: Subscription;

  /** La orden ya está en manos del broker (o verificando horario para enviarse): no se cancela ni caduca. */
  private ordenEnEnvio(ordersData: any): boolean {
    const cOID = String(ordersData?.orders?.[0]?.cOID ?? '');
    return this.envioEnCurso.has(cOID) || (this.verificandoHorarioCola && this.colaOrdenes[0] === ordersData);
  }

  /** Un paso de la cola: caduca las vencidas y, si se puede, envía la primera. */
  private procesarCola() {
    this.expirarOrdenesCola();
    let riesgooperaciontemporal = 0;
    if (this.colaOrdenes.length > 0) {
      let ordencolatemporal = this.colaOrdenes[0].orders[0];
      let isotemporal = isooperDeOrderRef(ordencolatemporal.cOID);
      let preciotemporal = 0;
      let stoplosstemporal = 0;
      this.operacionesActuales.forEach((operacion) => {
        if (operacion.isooper === isotemporal) {
          preciotemporal = operacion.precioentradareal;// considerar para bajista luego
          stoplosstemporal = operacion.stoplossinicial;
        }
      });

      riesgooperaciontemporal = (preciotemporal - stoplosstemporal) * ordencolatemporal.quantity;
    }
    if (this.colaOrdenes.length > 0 && this.existemargenbroker && this.existemargen && this.existeriesgo && ((this.riesgomaximo >= riesgooperaciontemporal) || (this.riesgomaximo == 0)) &&
      (this._cookieService.check('auto' + this.BrokoptimalWallet.idcartera) || this.esOrdenSincronizacion(this.colaOrdenes[0]))) {
      this.enviarSiMercadoAbierto(this.colaOrdenes[0]);
    } else {
      // console.log('no se puede enviar orden ');
      this.checkAndUpdateEstado();
    }
  }

  private encolar(ordersData: any, origen: OrigenOrden) {
    this.colaOrdenes.push(ordersData);
    this.encoladaEn.set(ordersData, Date.now());
    this.origenOrden.set(ordersData, origen);
    // MetaTrader: sale ya, sin esperar al tick de 3 s (mismo criterio que removeCurrentOrder). La marca
    // envioEnCurso evita el doble envío con el tick. IBKR mantiene el ritmo del tick.
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      setTimeout(() => this.procesarCola());
    }
  }

  /** Copias de las órdenes con su origen, solo para registrarlas en BD (broker/orderNuevo). */
  private conOrigen(orders: any[], ordersData: any): any[] {
    const origen = this.origenOrden.get(ordersData);
    return origen ? orders.map(o => ({ ...o, origen })) : orders;
  }

  /** Cancelación pedida desde la lista de órdenes (fila "En cola"). */
  private cancelarOrdenCola(cOID: string) {
    const item = this.colaOrdenes.find(o => o?.orders?.[0]?.cOID === cOID);
    if (!item) {
      this.toastr.info('La orden ya se envió o salió de la cola', 'Cola de órdenes');
      return;
    }
    if (this.ordenEnEnvio(item)) {
      this.toastr.warning('La orden se está enviando al broker, no se puede cancelar', 'Cola de órdenes');
      return;
    }
    this.ordenesSincronizacion.delete(cOID);
    const ticker = item.orders[0].ticker;
    this.descartarOrden(item, 'CANCELADA-COLA', 'Orden cancelada en cola', `Orden de ${ticker} cancelada antes de enviarse al broker.`);
  }

  /** Anula las órdenes que llevan más de TTL_COLA_MS en cola sin llegar al broker. */
  private expirarOrdenesCola() {
    const ahora = Date.now();
    [...this.colaOrdenes].forEach(item => {
      const desde = this.encoladaEn.get(item);
      if (desde === undefined || ahora - desde <= BrokerComponent.TTL_COLA_MS || this.ordenEnEnvio(item)) return;
      const cOID = String(item.orders?.[0]?.cOID ?? '');
      this.ordenesSincronizacion.delete(cOID);
      const motivo = this.estadoparaenviar ? ` (motivo: ${this.estadoparaenviar})` : '';
      this.descartarOrden(item, 'EXPIRADA-COLA', 'Orden caducada en cola',
        `La orden de ${item.orders?.[0]?.ticker} se anuló: no llegó al broker en ${BrokerComponent.TTL_COLA_MS / 1000} s${motivo}.`);
    });
  }

  private esOrdenSincronizacion(ordersData: any): boolean {
    return this.ordenesSincronizacion.has(ordersData?.orders?.[0]?.cOID ?? '');
  }
  existeriesgo: boolean = true;
  ordenPendiente: boolean = false;
  private whatIfInFlight = false;
  private whatIfRetryCount: Map<string, number> = new Map();
  /** broker_whatif para la columna margenbroker: una petición a la vez, solo si cambian las posiciones o cada MARGEN_WHATIF_INTERVALO_MS */
  private margenWhatIfSub: Subscription | null = null;
  private margenWhatIfClave = '';
  private margenWhatIfUltimo = 0;
  private readonly MARGEN_WHATIF_INTERVALO_MS = 60000;
  /** Salidas automáticas cuyo SL/TP (OCO) ya se canceló en el broker, por cOID. */
  private ocoCancelado = new Set<string>();
  private cancelandoOco = false;
  private cancelarOcoRetryCount: Map<string, number> = new Map();
  public walletBroker: Broker = {
    PoderAdquisitivo: 0,
    ValorLiquidativo: 0,
    MargenTotal: 0,
    FondosDisponible: 0,
    Efectivo: 0
  };

  public defaultBroker: Broker = {
    PoderAdquisitivo: 0,
    ValorLiquidativo: 0,
    MargenTotal: 0,
    FondosDisponible: 0,
    Efectivo: 0
  };
  private handleApiError(estado: boolean) {
    if (estado != this.apiIbkrAvailable) {
      this.apiIbkrAvailable = estado;
      localStorage.setItem('apiIbkrAvailable', String(estado));
      this.cdr.detectChanges(); // Asegura que la vista se actualice

    }
  }
  private checkAndUpdateEstado() {
    this.estadoparaenviar = '';

    if (!this._cookieService.check('auto' + this.BrokoptimalWallet.idcartera) && !this.esOrdenSincronizacion(this.colaOrdenes[0])) {
      this.estadoparaenviar = 'AUTOMATIZACION-DETENIDA';
    } else if (!this.existemargenbroker) {
      this.estadoparaenviar = 'MARGEN-BKR-INSUFICIENTE';
    } else if (!this.existemargen) {
      this.estadoparaenviar = 'MARGEN-INSUFICIENTE';
    } else if (!this.existeriesgo) {
      this.estadoparaenviar = 'RIESGO-INSUFICIENTE';
    } else if (!this.brokerOpen) {
      this.estadoparaenviar = 'BROKER-CERRADO';
    }

    if (this.colaOrdenes.length > 0 &&
      (this.estadoparaenviar !== this.previousEstado ||
        this.colaOrdenes.length !== this.previousColaLength)) {
      const detenida = this.estadoparaenviar === 'AUTOMATIZACION-DETENIDA';
      // Las órdenes de sincronización no dependen de la automatización: no se marcan ni se descartan.
      const ordenesEstado = detenida
        ? this.colaOrdenes.filter(o => !this.esOrdenSincronizacion(o))
        : this.colaOrdenes;
      this._sseservice.apiPostNew(
        'actualizarEstadoOperacionesOrdenes',
        {
          estado: this.estadoparaenviar,
          ordenes: ordenesEstado
        },
        this.licencia
      ).subscribe({
        next: (response: any) => {
          if (detenida) {
            this.colaOrdenes = this.colaOrdenes.filter(o => this.esOrdenSincronizacion(o));
            this.colaOrdenesService.updateColaOrdenes(this.colaOrdenes);
          }
          this.operacionesActuales = [];
        },
        error: (error: any) => {
        }
      });

      this.previousEstado = this.estadoparaenviar;
      this.previousColaLength = this.colaOrdenes.length;

    }
  }
  theme: any;
  responseData: any;

  constructor(private colaOrdenesService: ColaOrdenesService,
    private _sseservice: SseService, private toastr: ToastrService,
    public _cookieService: CookieService,
    private apiService: ApiService, private posicionesService: PosicionesService,
    private _brokerService: BrokerService,
    public dialog: MatDialog,
    public _route: ActivatedRoute,
    private temaservicio: TemaService,
    private cdr: ChangeDetectorRef,
    private _realTimeService: RealTimeService,
    private _ibrkService: ibrkServices, private positionsService: PositionsService,
    private router: Router, private companiaWebsocketService: CompaniaWebsocketService,
    private marketDataService: MarketDataService,
    private notificacionService: NotificacionService, private oauthService: OAuthService,
    private brokerAdapterFactory: BrokerAdapterFactory,
    private salidaService: SalidaOperacionBrokerService,
    private metaApiService: MetaApiService,
    private mt5GatewayService: Mt5GatewayService,
    private metaApiStreaming: MetaApiStreamingService,
    private brokerTimeService: BrokerTimeService,
    private metaapiCandlesSyncService: MetaapiCandlesSyncService,
    private brokerTabLock: BrokerTabLockService) {

  }

  /**
   * Reloj "HORA EXCHANGE": MetaApi usa el offset medido de la cuenta; IBKR la zona IANA del
   * exchange (FMP all-exchange-market-hours), la misma en la que llegan los datos de la API.
   */
  private actualizarRelojBroker(data: any): void {
    this.brokerOffsetMin = null;
    this.brokerClockText = '';
    if (data?.tipoBroker === 'METAAPI') {
      this.brokerClockZoneSeq++;
      this.brokerClockZone = null;
      this.brokerClockLabel = '';
      const accountId = data.metaApiAccountId ?? data.nombre;
      this.brokerTimeService.getOffsetMinutes(accountId).subscribe(offsetMin => this.brokerOffsetMin = offsetMin);
    } else {
      this.resolverZonaExchangeIbkr();
    }
    if (!this.brokerClockInterval) {
      this.brokerClockInterval = setInterval(() => {
        const now = new Date();
        if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
          this.brokerClockText = this.brokerTimeService.formatTime(now, this.brokerOffsetMin);
        } else {
          this.brokerClockText = this.brokerClockZone
            ? this.brokerTimeService.formatTimeInZone(now, this.brokerClockZone)
            : '';
        }
      }, 1000);
    }
  }

  /**
   * Las listas no guardan mercado padre (pueden mezclar exchanges), así que la zona se toma del
   * mercado de origen (tbl_compania.idmercado) de un activo vía horasdemercadoporidnectum.
   * Se prueban en orden las posiciones y los activos de la lista hasta dar con uno cuyo mercado
   * de origen tenga zona en exchange_market_hours (ETFs o listas propias no la tienen).
   * Se recalcula cuando tablamercado publica los activos del mercado.
   */
  private resolverZonaExchangeIbkr(): void {
    const seq = ++this.brokerClockZoneSeq;
    this.brokerClockZone = null;
    this.brokerClockLabel = '';
    const wallet = this.BrokoptimalWallet;
    if (!wallet || wallet.tipoBroker === 'METAAPI') return;
    const candidatos = [...new Set([
      ...(this.posicionesModel ?? []).map(p => p.idNectum),
      ...this.mercadoIdnectumsArray
    ])].filter(id => !!id).slice(0, 10);
    if (!candidatos.length) return;
    from(candidatos).pipe(
      concatMap(id => this.brokerTimeService.getMarketSchedule(id, wallet)),
      first(schedule => !!schedule?.timezone
        && !!this.brokerTimeService.formatTimeInZone(new Date(), schedule.timezone), null)
    ).subscribe(schedule => {
      if (seq !== this.brokerClockZoneSeq) return;
      if (!schedule) {
        console.warn('HORA EXCHANGE: ningún activo de la cartera tiene zona de exchange', candidatos);
        return;
      }
      this.brokerClockZone = schedule.timezone;
      this.brokerClockLabel = schedule.iso ?? '';
    });
  }

  getOptions(endPoint: string) {
    const options = { ...global.credentials }; // copy
    options.useGw = global.session.useGw;
    if (endPoint) {
      options.endPoint = endPoint;
      options.url = global.session.baseUrl + endPoint;
    }
    return options;
  }

  ngOnInit() {
    // La exclusividad de pestaña la garantiza BrokerTabGuard (Web Locks) antes de crear el componente
    localStorage.setItem('idcarterabroker', '0');
    // La cola de envío vive en memoria (empieza vacía): limpiar la copia persistida de una sesión
    // anterior para que la lista de órdenes no muestre filas "En cola" que ya no existen.
    this.colaOrdenesService.updateColaOrdenes(this.colaOrdenes);
    this.subCancelarCola = this.colaOrdenesService.cancelarCola$.subscribe(cOID => this.cancelarOrdenCola(cOID));

    // Pre-leer params del snapshot ANTES de que se configuren las suscripciones,
    // para que cuentaUrlParam esté definido cuando subBrokOptima dispare sincrónicamente.
    const snapshotCuenta = this._route.snapshot.queryParams['cuenta'];
    if (snapshotCuenta) {
      this.cuentaUrlParam = snapshotCuenta;
      this.cuentaUrlProcesada = true;
    }
    this.restaurarEstadoUrl();

    // Leer parámetro de cuenta de la URL (para navegaciones posteriores al mismo componente)
    this._route.queryParams.subscribe(params => {
      if (params['cuenta'] && !this.cuentaUrlProcesada) {
        console.log('Cuenta detectada en URL:', params['cuenta']);
        this.cuentaUrlParam = params['cuenta']; // Guardar para evitar doble apertura
        this.cuentaUrlProcesada = true; // Marcar como procesada
        // Solo abrir el diálogo si la cartera aún no está cargada (evita reapertura tras conectar MetaAPI)
        if (!this.BrokoptimalWallet || Object.keys(this.BrokoptimalWallet).length === 0) {
          setTimeout(() => {
            this.abrirDialogoInicioSesion(params['cuenta']);
          }, 500);
        }
      }
    });

    this.stkcfdSubscription = this._brokerService.stkcfd$.subscribe(
      value => {
        if (value === 'STK' || value === 'CFD')
          this.stkcfd = value;
      }
    );

    this.idnectumsSubscription = this._brokerService.idnectumsArray$.subscribe(
      (newIdnectums: number[]) => {
        console.log('>>> BROKER: Recibido del servicio idnectumsArray$:', newIdnectums);
        this.mercadoIdnectumsArray = newIdnectums;
        // Actualizar el socket con los nuevos IDs de mercado
        this.updateIdnectumsArray();
        if (this.BrokoptimalWallet && this.BrokoptimalWallet.tipoBroker !== 'METAAPI') {
          this.resolverZonaExchangeIbkr();
        }
      }
    );

    this.licencia = this._cookieService.get('auth_token');
    this.isBroker = true;
    console.log('ngOnInit se ejecuta');
    // Restaurar anchos persistidos
    setTimeout(() => this.restoreSavedWidths?.(), 80);
    // this.consultarDataRT();
    this.apiService.apiPost("parametricaparamodelos", true, {}, 2).then((response) => {
      this.intervalos = (response.data.periodos);
    });
    this.subCarteraActual = this._brokerService.valBrokIdeCarteras$.subscribe({
      next: (data: any) => {
        this.idCarteraActual = data;
      }
    });
    this.subBrokCompaniaMercado = this._brokerService.valBrokCompania$.subscribe({
      next: (data: any) => {
        if (!Array.isArray(data) || data.length === 0) return;
        if (this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') return;
        // Sin token (sesión cerrada) no se descarga: evita el toast "MetaAPI no configurado" y el diálogo automático
        if (!this.metaApiService.hasToken()) return;
        if (!this._brokerService.revisadosuscrito) return;

        // La tabla de mercado reemite la lista con cada tick de precio: actuar solo si cambian
        // los activos. Durante una descarga no se marca, para que el siguiente emit lo reintente.
        const clave = data.map((c: any) => c?.idNectum).filter((id: any) => id != null).sort().join(',');
        if (clave === this.claveMercadoDescargado || this.isLoadingMetaapi) return;
        this.claveMercadoDescargado = clave;

        if (this.metaApiService.avisarSiExcedeLimiteDescarga(data.length)) return;

        void this.descargarCandlesMetaapi(['1d'], data);
      }
    });
    this.subSincronizacionSolicitada = this.metaapiCandlesSyncService.sincronizacionSolicitada$
      .subscribe(() => void this.sincronizarVelasAlAbrirGrafica());
    this.subBrokOptima = this._brokerService.valBrokOptimaWallet$.subscribe({
      next: (data: any) => {
        if (!data) {
          this.BrokoptimalWallet = this._brokerService.getDefaultWallet();
          return;
        }
        this.BrokoptimalWallet = data;
        this.actualizarRelojBroker(data);

        // Set market selection in tablamercado component
        if (data?.idmercado && this.tablaMercado) {
          this.tablaMercado.gestcarterabyid(data.idmercado);
        }

        // Restaurar siempre el id de la cartera abierta: el bloque de abajo solo corre
        // la primera vez (iniciadoTiempoReal) y no cubre re-entradas al componente
        if (data?.idcartera) {
          localStorage.setItem('idcarterabroker', data.idcartera.toString());
        }

        console.log(' idcarterainiciar ' + this.BrokoptimalWallet.idcartera + ' revisarsuscrito ' + this._brokerService.revisadosuscrito);
        if (!this._brokerService.revisadosuscrito && this.BrokoptimalWallet.idcartera != null) {
          console.log('his._brokerService.iniciadoTiempoReal ' + this._brokerService.iniciadoTiempoReal);
          if (this.BrokoptimalWallet.idcartera && !this._brokerService.iniciadoTiempoReal) {
            this._brokerService.iniciadoTiempoReal = true;
            this.iniciarContadorRegresivo();
            this.DataBroker();
            if (data) {
              if (data.idcartera) {
                this._sseservice.apiGetNew('parametrosmodelo?idmodelo=' + data.idModelo).subscribe({
                  next: (data: any) => {
                    console.log(data);
                    this.datosmodelo = data.condicion;
                    console.log(this.datosmodelo + "datosmodelo");
                  }
                });
                this._sseservice.apiGetNew('broker/obtenerTrades/' + data.idcartera).subscribe({
                  next: (data: any) => {
                    //console.log('datos trades');
                    //console.log(data);
                    this.tradersActuales = data;
                  }
                });
                this._sseservice.apiGetNew('obtenerIdCartera2?idcartera=' + data.idcartera).subscribe({
                  next: (data: any) => {
                    if (data.status === 'success') {
                      console.log('IdCartera2:', data.idcartera2);
                      // Aquí puedes hacer lo que data con el idcartera2
                      // this.suscrito = data.success && this.BrokoptimalWallet.;
                      this.idcarterasuscrita = data.idcartera2;
                    } else {
                      console.error('Error:', data.message);
                    }
                  }
                });
                this._sseservice.apiGetNew('revisarSuscrito?nombre=' + encodeURIComponent(data.nombre)).subscribe({
                  next: (data: any) => {
                    if (data.status === 'success') {
                      this.suscrito = true;
                      this.aplicarPeriodoSuscripcion(data.periodosuscripcion, data.periodos);
                    } else {
                      this.suscrito = false;
                    }
                  }
                });
                if (data?.tipoBroker === 'METAAPI') {
                  const metaApiAccountId = data.metaApiAccountId ?? data.nombre;

                  this.positionsService.startPositionsUpdateMetaApi(
                    metaApiAccountId,
                    data.tipoBroker ?? 'METAAPI'
                  );

                  // Refresca broker_utc_offset_min / broker_offset_updated_at en tbl_metaapi_cuenta
                  // cada vez que se abre la cartera MetaApi (no solo durante el deploy inicial).
                  // Con el gateway local lo mide el gateway: el backend no llega a localhost.
                  const offset$ = this.metaApiService.isGateway()
                    ? this.mt5GatewayService.sincronizarOffset(metaApiAccountId)
                    : this._sseservice.apiGetWithAuth('metaapi/estado/' + metaApiAccountId, this.licencia);
                  offset$.subscribe({
                    next: () => {},
                    error: () => {}
                  });

                  this._sseservice.apiPostNew('broker/obtenercarterassuscripcion', { idcartera: data.idcartera }, this.licencia).subscribe({
                    next: (data: any) => {
                      this.carterasmetaapi = data.isos;
                      console.log('Carteras suscritas MetaAPI:', this.carterasmetaapi);
                      this.syncCarteraStream();
                      if (this.metaApiService.hasToken()) {
                        // Cuenta como la sincronización diaria del día: la revisión automática
                        // no volverá a pedir 1d hasta el siguiente día del broker.
                        const dia = this.diaBrokerActual();
                        void this.descargarCandlesMetaapi(['1d']).then(r => { if (r.ok) this.ultimoDiaSyncDiario = dia; });
                      }
                    }
                  });
                } else {
                  this.positionsService.startPositionsUpdate(data.nombre);
                }

                // Suscribirse a las actualizaciones de posiciones desde el broker.
                // Este bloque se re-ejecuta en cada reconexión/login: cancelar la suscripción
                // anterior para no acumular suscripciones (cada una lanzaba su propio whatif)
                this.subPositions?.unsubscribe();
                this.subPositions = this.positionsService.positions$.subscribe({
                  next: (positions: any[]) => {
                    if (!this.posicionesModel || this.posicionesModel.length === 0) {
                      return;
                    }

                    this.refrescarMargenBroker();

                    // Actualizar posiciones con datos del broker
                    let updated = false;
                    this.posicionesModel = this.posicionesModel.map(position => {
                      // Buscar datos actualizados para esta posición
                      const brokerData = positions.find(p => Number(p.conid) === Number(position.conid));
                      
                      if (brokerData && brokerData.mktPrice) {
                        updated = true;
                        const valtemp = this.calculateValorLatente(position, brokerData.mktPrice);
                        //console.log('>>> BROKER: Actualizando', position.isooper, position.cotizacion, '->', brokerData.mktPrice);
                        
                        return {
                          ...position,
                          preciocierre: brokerData.mktPrice,
                          cotizacion: brokerData.mktPrice,
                          valorlatente: valtemp,
                          profit: '(' + (Math.abs(position.porprofit) * 100) + ') ' + (brokerData.mktPrice + (brokerData.mktPrice * Math.abs(position.porprofit))).toFixed(2),
                          stoplossactual: '(' + Math.abs(position.porstoploss) * 100 + ') ' + (brokerData.mktPrice - (brokerData.mktPrice * Math.abs(position.porstoploss))).toFixed(2),
                          valorlatentepor: (valtemp / (position.precioentradareal * position.cantidadacciones) * 100),
                          horaCotizacion: Math.floor(Date.now() / 1000)
                        };
                      }
                      
                      return position;
                    });

                    if (updated) {
                      //console.log('>>> BROKER: Posiciones actualizadas:', this.posicionesModel);
                      // Notificar al servicio broker que las posiciones cambiaron
                      this._brokerService.updateBrokValPos(this.posicionesModel);
                      // Forzar detección de cambios en Angular
                      this.cdr.detectChanges();
                    }
                  },
                  error: (error) => console.error('Error en suscripción de posiciones:', error)
                });
              }
            }
            this._brokerService.revisadosuscrito = true;

          }

        }

        if (Object.keys(this.BrokoptimalWallet).length > 0 && this.idCarteraActual != this.BrokoptimalWallet.idcartera) {
          console.log("LAS CARTERAS SON DISTINTAS");
          this.walletMetrics = null;
          this.getOptimalWallet(this.BrokoptimalWallet, true, false);
          this._brokerService.updateBrokidcarteras(this.BrokoptimalWallet.idcartera);
        } else if (Object.keys(this.BrokoptimalWallet).length == 0 && !this.cuentaUrlParam) {
          // Solo abrir si no hay parámetro de cuenta en URL (para evitar apertura doble)
          this.abrirDialogoInicioSesion();
        }
        //console.log('datos cartera broker');
        //console.log(this.BrokoptimalWallet);
      }
    });

    // Si se llegó al componente con un parámetro cuenta en la URL y la cartera aún no está cargada,
    // abrir el diálogo con auto-selección de cuenta.
    if (this.cuentaUrlParam && (!this.BrokoptimalWallet || Object.keys(this.BrokoptimalWallet).length === 0)) {
      setTimeout(() => {
        this.abrirDialogoInicioSesion(this.cuentaUrlParam);
      }, 500);
    }

    this.subtema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });

    this.subActualizar = this._brokerService.valactualizarCartera$.subscribe({
      next: (data: any) => {
        if (data) {
          console.log("subActualizar = this._brokerService.valactualizarCartera$.subscribe");
          this.getOptimalWallet(this.BrokoptimalWallet, true, false);
          this._brokerService.updateactualizarCarteraBroker(false);

        }
      }
    });

    this.intervalSubscription = interval(5000).subscribe(() => {
      this.checkearStatus();
    });

    // Bucle de la cola: cada 3 s intenta enviar la primera orden. En MetaTrader, además, la
    // siguiente sale en cuanto termina la anterior (ver crearordenbroker → removeCurrentOrder);
    // el ritmo frente a MetaAPI lo pone el turno de /trade de MetaApiService.
    setInterval(() => this.procesarCola(), 3000);

    this.subscription = this.companiaWebsocketService.getCompaniaUpdates()
      .subscribe(
        (data) => {
          // console.log('Received data gestor:', data);
          this.updateValCartera(data);
        },
        (error) => console.error('Error:', error)
      );
  }
  private calculateValorLatente(position: any, newClosePrice: number): number {
    const difference = newClosePrice - position.precioentradareal;
    return difference * position.cantidadacciones;
  }

  private aplicarPeriodoSuscripcion(periodosuscripcion: any, periodosCsv?: string): void {
    const periodoId = Number(periodosuscripcion);
    const periodoValido = Number.isInteger(periodoId) && periodoId >= 1 && periodoId <= 8;

    if (periodoValido) {
      this.periodoSuscripcionId = periodoId;
      this.periodoSuscripcionIntervalSeconds = this.getPeriodoSuscripcionIntervalSeconds(periodoId);
    } else {
      this.periodoSuscripcionId = 0;
      this.periodoSuscripcionIntervalSeconds = 32;
    }

    this.periodosCarteraActual = periodosCsv
      ? Array.from(new Set(periodosCsv.split(',').map(v => v.trim()).filter(v => v !== '')))
      : (periodoValido ? [String(periodoId)] : []);

    this.modeloRevisionNextAt = this.getNextRevisionTimestamp(new Date());
  }

  private getPeriodoSuscripcionIntervalSeconds(periodoId: number): number {
    switch (periodoId) {
      case 1: return 60;
      case 2: return 300;
      case 3: return 900;
      case 4: return 1800;
      case 5: return 3600;
      case 6: return 86400;
      case 7: return 14400;
      case 8: return 604800;
      default: return 32;
    }
  }

  private getNextRevisionTimestamp(baseDate: Date = new Date()): number {
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI' && this.brokerOffsetMin != null
        && (this.periodoSuscripcionId === 6 || this.periodoSuscripcionId === 7)) {
      const stepHours = this.periodoSuscripcionId === 6 ? 24 : 4;
      return this.brokerTimeService.getNextBrokerBoundaryMs(baseDate, stepHours, this.brokerOffsetMin);
    }

    if (this.periodoSuscripcionId < 1 || this.periodoSuscripcionId > 8) {
      return baseDate.getTime() + (this.periodoSuscripcionIntervalSeconds * 1000);
    }

    const nextDate = new Date(baseDate.getTime());

    switch (this.periodoSuscripcionId) {
      case 1:
        nextDate.setSeconds(0, 0);
        nextDate.setMinutes(nextDate.getMinutes() + 1);
        break;
      case 2:
        nextDate.setSeconds(0, 0);
        nextDate.setMinutes(Math.floor(nextDate.getMinutes() / 5) * 5 + 5);
        break;
      case 3:
        nextDate.setSeconds(0, 0);
        nextDate.setMinutes(Math.floor(nextDate.getMinutes() / 15) * 15 + 15);
        break;
      case 4:
        nextDate.setSeconds(0, 0);
        nextDate.setMinutes(Math.floor(nextDate.getMinutes() / 30) * 30 + 30);
        break;
      case 5:
        nextDate.setMinutes(0, 0, 0);
        nextDate.setHours(nextDate.getHours() + 1);
        break;
      case 6:
        nextDate.setHours(0, 0, 0, 0);
        nextDate.setDate(nextDate.getDate() + 1);
        break;
      case 7:
        nextDate.setMinutes(0, 0, 0);
        nextDate.setHours(Math.floor(nextDate.getHours() / 4) * 4 + 4);
        break;
      case 8: {
        nextDate.setHours(0, 0, 0, 0);
        const dayOfWeek = nextDate.getDay();
        const daysUntilMonday = (8 - dayOfWeek) % 7 || 7;
        nextDate.setDate(nextDate.getDate() + daysUntilMonday);
        break;
      }
      default:
        return baseDate.getTime() + (this.periodoSuscripcionIntervalSeconds * 1000);
    }

    return nextDate.getTime();
  }
  updateValCartera(data: any) {
   
    this.marketDataService.updateMarketData(data);

  }

  private iniciarContadorRegresivo() {

    if (this.modeloRevisionTimerId) {
      clearInterval(this.modeloRevisionTimerId);
    }

    this.modeloRevisionNextAt = this.getNextRevisionTimestamp(new Date());

    const actualizarToastr = (tiempoRestante: number) => {
      this.notificacionService.updateTimerNotification(
        `Auto · ${this.notificacionService.formatTiempoRestante(tiempoRestante)}`,
        'Próxima ejecución'
      );
    };

    this.modeloRevisionTimerId = setInterval(() => {
      if (!this.isLoggin) {
        // Broker desconectado: se pausa el contador (no se revisa el modelo ni se sincronizan velas).
        this.notificacionService.updateTimerNotification('Broker desconectado', 'Revisión pausada');
        return;
      }

      const auto = this._cookieService.check('auto' + this.BrokoptimalWallet.idcartera);
      const now = Date.now();

      if (auto) {
        actualizarToastr(Math.max(0, Math.ceil((this.modeloRevisionNextAt - now) / 1000)));
      }

      if (now >= this.modeloRevisionNextAt) {
        this.modeloRevisionNextAt = this.getNextRevisionTimestamp(new Date());
        if (!auto) {
          // Sin automatización no se revisa el modelo, pero las velas se siguen descargando
          // para que las gráficas avancen.
          void this.sincronizarVelasSinRevision();
        } else if (!this.revisandomodeloia) {
          this.valoresTiempoReal();
        }
      }
    }, 1000);

    // const intervaloDos = setInterval(() => {
    // console.log('interval dos '+new Date());
    this.tradesordenesTiempoReal();
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      this.startMetaApiRealTimeCartera();
    }
    // }, 5000);

  }
  disabledMargin(event: any) {
    console.log(event.target.value);
    if (this.BrokoptimalWallet.tipocuenta == 'MARGEN') {
      this.BrokoptimalWallet.poderCompra = 100000
      this.disabledByAccount = false;
    }
    else {
      this.BrokoptimalWallet.poderCompra = 200000
      this.disabledByAccount = true;
    }
  }
  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private procesarCompania(compania: any): Promise<void> {
    return new Promise((resolve) => {
      this.oauthService.apiGetIbrk(`/iserver/secdef/search?symbol=${compania.iso}&name=true`).subscribe({
        next: (resp => {
          try {
            console.log(`getOptimalWallet resp for ${compania.iso}:`, resp);
            const cfdSection = resp.find((item: any) =>
              item.sections && item.sections.some((section: any) => section.secType === 'CFD')
            );

            if (cfdSection) {
              const cfdInfo = cfdSection.sections.find((section: any) => section.secType === 'CFD');
              if (cfdInfo && cfdInfo.conid) {
                console.log(`CFD conid for ${compania.iso}:`, cfdInfo.conid);
                compania.cfdConid = cfdInfo.conid;

                this.apiService.apiPost('actualizarConidCfd', true, {
                  conid: compania.conid, conidcfd: cfdInfo.conid
                }, 2).then((response) => {
                  console.log(`ConidCfd actualizado para ${compania.iso}:`, response);
                  resolve();
                });
              } else {
                resolve();
              }
            } else {
              console.log(`No CFD found for ${compania.iso}`);

              this.apiService.apiPost('actualizarConidCfd', true, {
                conid: compania.conid, conidcfd: -1
              }, 2).then((response) => {
                console.log(`ConidCfd actualizado para ${compania.iso}:`, response);
                resolve();
              });
              resolve();
            }
          } catch (error) {
            console.log('error de formato ');
          }
        }),
        error: (error => {
          console.error(`Error fetching data for ${compania.iso}:`, error);
          resolve();
        })
      });
    });
  }
  /**
   * Publica las métricas de la cartera `w` (clave por cartera en localStorage + binding al hijo).
   * `ultimaOpe` = última fila del evento 'ope'; sin ella la cartera no tiene operaciones.
   *
   * Riesgo, igual que el backend (apiController.Recalcular):
   *  - w.riesgomaximo es un %; el riesgo máximo en dinero es capitalinicial * % / 100 (riesgoMaximoInicial).
   *  - ope.riesgomaximo es el riesgo que QUEDA: arranca en riesgoMaximoInicial, cada entrada resta
   *    riesgooperacion + comisión/2 y cada salida lo reembolsa.
   *  => riesgoActual (en uso) = riesgoMaximoInicial - ope.riesgomaximo; sin operaciones = 0.
   */
  private guardarWalletMetrics(w: any, ultimaOpe?: any): void {
    if (!w?.idcartera) return;
    const riesgoMaximoInicial = +((+w.capitalinicial || 0) * (+w.riesgomaximo || 0) / 100).toFixed(2);
    const riesgoRestante = ultimaOpe ? +ultimaOpe.riesgomaximo : riesgoMaximoInicial;
    const metrics: WalletMetrics = {
      valorLiquidativo: ultimaOpe ? +ultimaOpe.valorliquidativo.toFixed(2) : +(w.valorLiquidativo || w.capitalinicial || 0),
      riesgomaximo: riesgoMaximoInicial,
      riesgoActual: +Math.max(0, riesgoMaximoInicial - riesgoRestante).toFixed(2),
      margen: ultimaOpe ? +ultimaOpe.margentotal.toFixed(2) : 0,
      controlMarginCall: +w.controlMarginCall || 0,
    };
    localStorage.setItem(walletMetricsKey(w.idcartera), JSON.stringify(metrics));
    // Si el cálculo terminó después de cambiar de cartera, no pisar la barra de la cartera nueva
    if (this.BrokoptimalWallet?.idcartera === w.idcartera) {
      this.walletMetrics = metrics;
    }
  }

  getOptimalWallet(data: any, isGestion: boolean, isBRoker: boolean) {
    if(data.tipoBroker === 'METAAPI') {
      data.metaapi= true;
    }
    let endpoint = 'Recalcular?';
    if (this.isCalculating) {
      console.log('Calculation already in progress, queuing request');
      return;
    }
    let liqval: any[] = [];
    let ventOp: any[] = [];
    let vla: any[] = [];
    let rentabilida: any[] = [];
    let riesgo: any[] = [];
    let rendimiendoAnual: any[] = [];
    let pos: any[] = [];
    let ope: any[] = [];
    let hayOperaciones = false;
    this.loading = true;
    this.errString = '';

    this.isCalculating = true;

    this._sseservice.apiGetSse(endpoint, true, data).subscribe({
      next: (resp: any) => {
        if (resp.name === 'ope') {
          ope.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokOpe(ope);
            console.log(resp.name);
          }
          if (resp.data.length > 0) {
            var temp = resp.data[resp.data.length - 1];
            this.BrokoptimalWallet.margen = temp.margentotal.toFixed(2);
            this.BrokoptimalWallet.fondosDisponibles = temp.fondosdisponibles.toFixed(2);
            this.BrokoptimalWallet.poderCompra = temp.podercompra.toFixed(2);
            this.BrokoptimalWallet.efectivo = temp.efectivo.toFixed(2);
            this.BrokoptimalWallet.valorLiquidativo = temp.valorliquidativo.toFixed(2);
            this.efectivopositivo = this.BrokoptimalWallet.efectivo > 0;
            this.riesgomaximo = temp.riesgomaximo.toFixed(2);
            hayOperaciones = true;
            this.guardarWalletMetrics(data, temp);
            console.log(temp);
            if (resp.data.length > 2) {
              var tempoayer = resp.data[resp.data.length - 2];
              console.log(tempoayer);

              if (temp.riesgooperacion < tempoayer.riesgomaximo) {
                this.existeriesgo = true;
                console.log("Riesgo dentro de los parametros");
                this.previousEstado = 'EXISTE-RIESGO';
              }
            }

          }
        } else if (resp.name === 'vla') {
          vla.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokValLatente(vla);
            const lastLiqValArr = liqval[liqval.length - 1];
            const lastLiqVal = lastLiqValArr && lastLiqValArr.length > 0 ? lastLiqValArr[lastLiqValArr.length - 1] : undefined;
            // Partir siempre de vacío: si el último día de 'vla' no coincide con el último 'vli'
            // (p. ej. se cerró la única operación) no quedan posiciones vigentes y no debe
            // re-emitirse el modelo del cálculo anterior.
            this.posicionesModel = [];
            if (vla[0].length > 0) {
            this.lastBusinessDayData = this.getLastBusinessDayData(vla[0]);
            if (this.lastBusinessDayData && lastLiqVal && this.lastBusinessDayData[0].fechaintervalo === lastLiqVal.fechavalor) {
              this.posicionesModel = this.posicionesService.agregarPosicionesDesdeUltimoValorLiquidativo(this.lastBusinessDayData, this.posicionesModel);

            // Actualizar socket con IDs combinados de cartera y mercado
              this.updateIdnectumsArray();
              if (!this.brokerClockZone && this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') {
                this.resolverZonaExchangeIbkr();
              }
            }
          }

            pos.push(this.posicionesModel);
            this._brokerService.updateBrokValPos(pos);
            console.log("posiciones actualizadas con el ultimo valor de cierre");
            //console.log(pos);
          }
        } else if (resp.name === 'vli') {
          liqval.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokValLiq(liqval);

            console.log(resp.name);
          }
        } else if (resp.name === 'pos') {
          console.log("posiciones recibidas");
        } else if (resp.name === 'ven') {
          ventOp.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokValVentas(ventOp);
            console.log(resp.name);
            //  console.log(ventOp);
          }
        } else if (resp.name === 'ren') {
          rentabilida.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokRentabilidad(rentabilida);
            console.log(resp.name);
          }
        } else if (resp.name === 'rie') {
          riesgo.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokRiesgo(riesgo);
            console.log(resp.name);
          }
        } else if (resp.name === 'rea') {
          rendimiendoAnual.push(resp.data);
          if (this.isBroker) {
            this._brokerService.updateBrokRendAnual(rendimiendoAnual);
            console.log(resp.name);
          }
        } else if (resp.name === 'fin') {
          this.isCalculating = false;
          // 'ope' llega en bloques que pueden venir vacíos: solo al final sabemos si no hubo operaciones
          if (!hayOperaciones) {
            this.guardarWalletMetrics(data);
          }
          console.log("finalizo el envio de datos");

        } else if (resp.name === 'err') {
          //a this.errString concatenar resp.data
          this.errString += resp.data;

          this.errString
          let errorstring = resp.data;
          let titulo = '';
          if (errorstring.includes('han superado los Requerimientos de Margen')) {
            this.existemargen = false;
            titulo = 'Control Margin Call %';
          }
          if (errorstring.includes('Se ha superado los Requerimientos de Margen para su carter')) {
            this.existemargen = false;
            titulo = 'Control Margin Call %';
          }
          if (errorstring.includes('Se ha superado el riesgo máximo establecido')) {
            this.existeriesgo = false;
            titulo = 'Riesgo Maximo';
          }
          if (errorstring.includes('e ha superado el riesgo para una nueva operacion')) {
            this.existeriesgo = false;
            titulo = 'Riesgo para Nueva Operacion';
          }
          //if (errorstring.includes('')) {
          // this.existemargen = false;
          //   titulo = 'Margen Superado';
          //  }
          console.log("", resp.name);
          console.log(resp.data);
          this.toastr.error(resp.data, titulo, { timeOut: 30000, positionClass: 'toast-top-center' });
          this.guardarNotificacion(new Notificacion(titulo, errorstring, 'BROKER - ' + this.BrokoptimalWallet.nombre));
        }
      }, error(err) {
        console.log("hubo un error")
      }, complete: () => {
        this.isCalculating = false;
        console.log("se COMPLETO el envio de datos.");
        // Definimos las condiciones de error que estamos buscando
        const errorConditions = [
          'han superado los Requerimientos de Margen',
          'Se ha superado los Requerimientos de Margen para su carter',
          'Se ha superado el riesgo máximo establecido',
          'e ha superado el riesgo para una nueva operacion'
        ];
        //if(this.errString.length > 0) {

        // Verificamos si alguno de estos errores está presente en errString
        if (this.errString.includes(errorConditions[0]) || this.errString.includes(errorConditions[1])) { this.existemargen = false; }
        else {
          this.existemargen = true;
        }
        if (this.errString.includes(errorConditions[2]) || this.errString.includes(errorConditions[3])) {
          this.existeriesgo = false;
        } else { this.existeriesgo = true; }

        // } else {
        //   this.existemargen = true;
        //   this.existeriesgo = true;
        // }  
        //llamar a la grafica
        this.loading = false;
        this.cdr.detectChanges();
        this._brokerService.updateBrokExecuteGrap(true);
      }
    });

  }
  showTab(tab: any) {
    if (tab == 'cartera') {
      console.log(tab);
      this.cartera = !this.cartera;
      localStorage.setItem('broker_panel_cartera', String(this.cartera));
    } else {
      this.listaMercado = !this.listaMercado;
      localStorage.setItem('broker_panel_listaMercado', String(this.listaMercado));
    }
    // Trigger layout recalculation after panel visibility changes
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }
  reset() {

    this.posicionesModel = [];
    let dataJson = {
      idcartera: this.BrokoptimalWallet.idcartera,
      nombre: this.BrokoptimalWallet.nombre
    }
    console.log("esto enviamos al backend: ", dataJson);

    this._sseservice.apiGetNew('ordenes-pendientes/' + this.BrokoptimalWallet.idcartera).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '380px',
            height: '250px',
            panelClass: this.theme,
            data: {
              msj: '¡Atencion! Todos los datos de operaciones se Eliminaran, Las ordenes pendientes se cancelarn', icon: 'warning'
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('El diálogo se cerró');
            if (result) {
              for (const orden of data) {
                this.oauthService.apiDeleteIbrk('/iserver/account/' + this.BrokoptimalWallet.nombre + '/order/' + orden.orderId).subscribe({
                  next: (response: any) => {
                    console.log("Orden Cancelada: ", orden.orderId);
                  },
                  error: (error: any) => {
                    console.error("Error al cancelar la orden: ", error);
                  }
                });
              }
              this.colaOrdenesService.clearLocalStorageForCartera(this.BrokoptimalWallet.idcartera);
              this._sseservice.apiPostNew('broker/reset', dataJson, this.licencia).subscribe({
                next: (data: any) => {
                  console.log(data);
                  if (data.status) {
                    //this._brokerService.updateactualizarCartera(true);verificar bucle
                    this.BrokoptimalWallet.capitalinicial = 100000;
                    this.BrokoptimalWallet.valorLiquidativo = 0;
                    this.BrokoptimalWallet.fondosDisponibles = 0;
                    this.BrokoptimalWallet.poderCompra = 200000;
                    this.BrokoptimalWallet.efectivo = 100000;
                    this.toastr.success("Cartera reseteada exitosamente");
                    this.operacionesActuales = [];
                    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') 
                    this._sseservice.apiPostNew('metaapi/reset/'+this.BrokoptimalWallet.metaApiAccountId, {}, this.licencia).subscribe({
                      next: (data: any) => {
                        console.log(data);
                        
                      },
                      error: (error: any) => {
                        console.error("Error al resetear MetaAPI: ", error);
                        this.toastr.error("Error al resetear MetaAPI");
                      }
                    });
                  }
                  this.getOptimalWallet(this.BrokoptimalWallet, true, false);
                  this._brokerService.updatecargarListas(true);
                  this.inicializarData();
                  if (this.tablaMercado) {
                    this.tablaMercado.buscarCompania();
                  }
                }
              })
            }
          });
        } else {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '380px',
            height: '250px',
            panelClass: this.theme,
            data: {
              msj: '¡Atencion! Todos los datos de operaciones se Eliminaran'
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('El diálogo se cerró');
            if (result) {
              this.colaOrdenesService.clearLocalStorageForCartera(this.BrokoptimalWallet.idcartera);
              this._sseservice.apiPostNew('broker/reset', dataJson, this.licencia).subscribe({
                next: (data: any) => {
                  console.log(data);
                  if (data.status) {
                    //this._brokerService.updateactualizarCartera(true);verificar bucle
                    this.BrokoptimalWallet.capitalinicial = 100000;
                    this.BrokoptimalWallet.valorLiquidativo = 0;
                    this.BrokoptimalWallet.fondosDisponibles = 0;
                    this.BrokoptimalWallet.poderCompra = 200000;
                    this.BrokoptimalWallet.efectivo = 100000;
                    this.toastr.success("Cartera reseteada exitosamente");
                    if (this.BrokoptimalWallet.tipoBroker === 'METAAPI') 
                    this._sseservice.apiPostNew('metaapi/reset/'+this.BrokoptimalWallet.metaApiAccountId, {}, this.licencia).subscribe({
                      next: (data: any) => {
                        console.log(data);
                        
                      },
                      error: (error: any) => {
                        console.error("Error al resetear MetaAPI: ", error);
                        this.toastr.error("Error al resetear MetaAPI");
                      }
                    });
                  }
                  this.getOptimalWallet(this.BrokoptimalWallet, true, false);
                  this._brokerService.updatecargarListas(true);
                  this.inicializarData();
                  if (this.tablaMercado) {
                    this.tablaMercado.buscarCompania();
                  }
                }
              })
            }
          });
        }
      }
    });
    this.operacionesActuales = [];

  }

  limpiar() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: '¡Atencion! Todos los datos de operaciones, modelos, etc se Eliminaran'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        this._sseservice.apiPostNew('limpiar', {}, this.licencia).subscribe({

        });
      }
    });
  }
  expandirDiv() {
    this.texto = "<<";
    this.mouseSobreDiv = true;
  }
  contraerDiv() {
    this.texto = ">>";
    this.mouseSobreDiv = false;
  }

  startResizing(event: MouseEvent, column: HTMLElement) {
    if (column && column.tagName === 'DIV') {
      const dataKey = column.getAttribute('data-key') || '';
      const minWidth = 200;
      const maxWidth = Math.floor(window.innerWidth * 0.7);
      const initialX = event.clientX;
      const initialWidth = column.offsetWidth;

      const mouseMoveListener = (mouseEvent: MouseEvent) => {
        let width = initialWidth + (mouseEvent.clientX - initialX);
        if (width < minWidth) width = minWidth;
        if (width > maxWidth) width = maxWidth;
        column.style.width = width + 'px';
      };

      const mouseUpListener = () => {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('mouseup', mouseUpListener);
        try {
          const w = column.offsetWidth;
          if (dataKey) localStorage.setItem(dataKey, String(w));
        } catch (e) {}
      };

      document.addEventListener('mousemove', mouseMoveListener);
      document.addEventListener('mouseup', mouseUpListener);
    }
  }

  private restoreSavedWidths(): void {
    try {
      const keys = ['broker_col_cartera', 'broker_col_lista'];
      keys.forEach(key => {
        const v = localStorage.getItem(key);
        if (v) {
          const el = document.querySelector(`[data-key="${key}"]`) as HTMLElement;
          if (el) el.style.width = v + 'px';
        }
      });
    } catch (e) {}
  }

  openDialog(): void {
    let cartera = JSON.parse(JSON.stringify(this.BrokoptimalWallet));
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(ReconfiguracionDialogComponent, {
      width: '30%',
      minWidth: '380px',
      maxHeight: '90vh',
      panelClass: dialogClass,
      data: { optimaWallet: cartera, isBroker: true, idcarterasuscrita: this.idcarterasuscrita }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      this.DataBroker();
    });
  }

  async inicializarData(): Promise<void> {
    await this._brokerService.updateBrokOpe([]);
    await this._brokerService.updateBrokValLatente([]);
    await this._brokerService.updateBrokValLiq([]);
    await this._brokerService.updateBrokValPos([]);
    await this._brokerService.updateBrokValVentas([]);
    await this._brokerService.updateBrokRentabilidad([]);
    await this._brokerService.updateBrokRiesgo([]);
    await this._brokerService.updateBrokRendAnual([]);
    await this._brokerService.updateBrokcompaniaMercado([]);
  }


  private brokerWindowRef: Window | null = null;

  openBrokOp() {
    // La pantalla de operaciones no está disponible para MetaTrader
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') return;
    // Check if window exists and is not closed
    if (this.brokerWindowRef && !this.brokerWindowRef.closed) {
      // Focus existing window
      this.brokerWindowRef.focus();

      // Show notification
      this.toastr.success('La ventana de operaciones ya está abierta en otra pestaña', 'Aviso', {
        timeOut: 3000,
        positionClass: 'toast-top-right'
      });

      return;
    }

    const data: any = {
      idcartera: this.BrokoptimalWallet.idcartera,
      nombre: this.BrokoptimalWallet.nombre,
      tipoBroker: this.BrokoptimalWallet.tipoBroker ?? 'IBKR',
      metaApiAccountId: this.BrokoptimalWallet.metaApiAccountId ?? ''
    };

    // Create URL tree with the route and query params
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/broker-operations'], {
        queryParams: data
      })
    );

    // Open in new tab and store reference
    this.brokerWindowRef = window.open(url, '_blank');

    // Optional: Handle window close
    if (this.brokerWindowRef) {
      this.brokerWindowRef.onbeforeunload = () => {
        this.brokerWindowRef = null;
      };
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    this.cdr.detectChanges();
    if (event.index === TAB_CONTROL) this.actualizarDesdeDate();
    this.syncUrlEstado();
  }

  private actualizarDesdeDate(): void {
    // Same computation as confirmar(): get desd from first operation
    this._brokerService.valBrokOp$.pipe(first()).subscribe(primerValor => {
      let desd = new Date();
      if (Array.isArray(primerValor) && primerValor.length > 0) {
        if (Array.isArray(primerValor[0]) && primerValor[0].length > 0) {
          if (primerValor[0][0] && primerValor[0][0].fechaOperacion !== undefined) {
            desd = primerValor[0][0].fechaOperacion;
          }
        }
      }
      this.desdeDate = desd;
    });
  }

  togglePanelControl(clave: PanelControl): void {
    const prop = PANELES_CONTROL[clave];
    this[prop] = !this[prop];
    this.syncUrlEstado();
  }

  /** Restaura pestaña y paneles de Control Operativa desde `?tab=` y `?paneles=` (sobrevive a F5). */
  private restaurarEstadoUrl(): void {
    const params = this._route.snapshot.queryParams;
    const idx = BROKER_TABS.indexOf(params['tab']);
    if (idx >= 0) this.selectedTab = idx;
    if (params['paneles'] != null) {
      const activos = String(params['paneles']).split(',');
      (Object.keys(PANELES_CONTROL) as PanelControl[])
        .forEach(clave => this[PANELES_CONTROL[clave]] = activos.includes(clave));
    }
    // En la primera selección mat-tab-group no emite selectedTabChange, así que onTabChange no lo calcula
    if (this.selectedTab === TAB_CONTROL) this.actualizarDesdeDate();
  }

  /** Refleja pestaña y paneles en la URL; merge conserva ?cuenta= y replaceUrl no llena el historial. */
  private syncUrlEstado(): void {
    const paneles = (Object.keys(PANELES_CONTROL) as PanelControl[]).filter(clave => this[PANELES_CONTROL[clave]]);
    this.router.navigate([], {
      relativeTo: this._route,
      replaceUrl: true,
      queryParamsHandling: 'merge',
      queryParams: { tab: BROKER_TABS[this.selectedTab], paneles: paneles.join(',') },
    });
  }

  refrescar() {
    this.getOptimalWallet(this.BrokoptimalWallet, true, false);
    this._brokerService.updatecargarListas(true);

    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      const accountId = this.BrokoptimalWallet.metaApiAccountId ?? this.BrokoptimalWallet.nombre;
      const end = new Date().toISOString();
      const start = new Date(Date.now() - BrokerComponent.DEALS_VENTANA_AMPLIA_MS).toISOString();
      this.metaApiService.getHistoryDeals(accountId, start, end).subscribe({
        next: (deals: any[]) => {
          if (!deals || deals.length === 0) return;
          this._sseservice.apiPostNew('metaapi/history-deals/' + accountId, deals, this.licencia).subscribe({
            next: (res: any) => console.log('[MetaAPI deals] guardados:', res.inserted),
            error: (err: any) => console.error('[MetaAPI deals] error al guardar:', err)
          });
        },
        error: (err: any) => console.error('[MetaAPI] getHistoryDeals error:', err)
      });
    }
  }
  ngAfterViewInit() {
    // On page load the subBrokOptima subscription fires before tablaMercado is
    // available (ViewChild not yet set). Retry here now that the view is ready.
    if (this.BrokoptimalWallet?.idmercado && this.tablaMercado) {
      this.tablaMercado.gestcarterabyid(this.BrokoptimalWallet.idmercado);
    }
  }

  /**
   * Rellena margenbroker de posicionesModel con broker_whatif. Se llama en cada emisión de posiciones
   * (cada 5 s y por pestaña), así que solo pide si no hay una petición en curso y han cambiado las
   * posiciones o pasó MARGEN_WHATIF_INTERVALO_MS. MetaAPI no tiene whatif.
   */
  private refrescarMargenBroker(): void {
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') return;
    if (this.margenWhatIfSub && !this.margenWhatIfSub.closed) return;

    const nombre = this.BrokoptimalWallet?.nombre;
    if (!nombre) return;
    const clave = nombre + '|' + this.posicionesModel.map(p => p.isooper).sort().join(',');
    if (clave === this.margenWhatIfClave && Date.now() - this.margenWhatIfUltimo < this.MARGEN_WHATIF_INTERVALO_MS) return;
    // Se marca antes de pedir: si falla, no se reintenta hasta el siguiente intervalo
    this.margenWhatIfClave = clave;
    this.margenWhatIfUltimo = Date.now();

    this.margenWhatIfSub = this._sseservice.apiPostNew('broker/broker_whatif', { nombre }, this.licencia).subscribe({
      next: (data2: any[]) => {
        this.datawhatif = data2;
        // Helpers
        const toNum = (v: any): number | null => {
          if (v === null || v === undefined) return null;
          const n = Number(String(v).replace(/,/g, ''));
          return Number.isFinite(n) ? n : null;
        };
        const getIso = (row: any): string | null => {
          if (row?.isooper) return row.isooper;
          if (row?.['ïsooper']) return row['ïsooper'];
          const cOID: string = row?.cOID;
          if (typeof cOID === 'string' && cOID.includes('-') && cOID.includes(':')) {
            return isooperDeOrderRef(cOID).trim() || null;
          }
          return null;
        };

        // Sumar initial.change por isooper (si hay varios registros del mismo isooper)
        const sumByIso: Record<string, number> = (Array.isArray(this.datawhatif) ? this.datawhatif : []).reduce((acc, r: any) => {
          const iso = getIso(r);
          const change = toNum(r?.whatIf?.initial?.change);
          if (!iso || change == null) return acc;
          acc[iso] = (acc[iso] ?? 0) + change;
          return acc;
        }, {} as Record<string, number>);

        // Actualizar tabla: crear NUEVO array para que Angular detecte cambios
        this.posicionesModel = (this.posicionesModel || []).map(row => ({
          ...row,
          margenbroker: sumByIso[row.isooper] ?? 0
        }));
      },
      error: (err) => console.error('Error obteniendo broker_whatif:', err)
    });
  }

  private static leerAltoControl(clave: string): number {
    try {
      const alto = Number(localStorage.getItem(clave));
      if (alto > 0) return alto;
    } catch { }
    return BrokerComponent.ALTO_CONTROL_DEFECTO;
  }

  /** Arrastre del divisor bajo un panel de Control Operativa: abajo lo agranda, arriba lo achica. */
  iniciarResizeControl(ev: MouseEvent, panel: keyof typeof BrokerComponent.PANELES_CONTROL, comp: { actualizarViewport(): void }) {
    ev.preventDefault();
    this.finResizeControl?.();
    const { prop, clave } = BrokerComponent.PANELES_CONTROL[panel];
    const startY = ev.clientY;
    const altoInicial = this[prop];
    const max = Math.round(window.innerHeight * 0.7);
    const mover = (e: MouseEvent) => {
      this[prop] = Math.min(max, Math.max(80, altoInicial + e.clientY - startY));
      this.cdr.detectChanges();
      comp.actualizarViewport();
    };
    const soltar = () => {
      document.removeEventListener('mousemove', mover);
      document.removeEventListener('mouseup', soltar);
      document.body.style.userSelect = '';
      this.finResizeControl = null;
      try { localStorage.setItem(clave, String(this[prop])); } catch { }
    };
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', soltar);
    this.finResizeControl = soltar;
  }

  /** Doble clic en el divisor: vuelve al alto por defecto. */
  resetAltoControl(panel: keyof typeof BrokerComponent.PANELES_CONTROL, comp: { actualizarViewport(): void }) {
    const { prop, clave } = BrokerComponent.PANELES_CONTROL[panel];
    this[prop] = BrokerComponent.ALTO_CONTROL_DEFECTO;
    try { localStorage.removeItem(clave); } catch { }
    this.cdr.detectChanges();
    comp.actualizarViewport();
  }

  ngOnDestroy() {
    this.finResizeControl?.();
    if (this.modeloRevisionTimerId) {
      clearInterval(this.modeloRevisionTimerId);
      this.modeloRevisionTimerId = null;
    }
    if (this.brokerClockInterval) {
      clearInterval(this.brokerClockInterval);
      this.brokerClockInterval = null;
    }
    // Liberar /broker para que otra pestaña pueda abrirlo
    this.brokerTabLock.release();

    if (this.stkcfdSubscription) {
      this.stkcfdSubscription.unsubscribe();
    }
    if (this.intervalSubscription && !this.intervalSubscription.closed) {
      console.log("se cierra subscripcion");
      this.intervalSubscription.unsubscribe();
    }
    this.subBrokOptima.unsubscribe();
    this.subSincronizacionSolicitada?.unsubscribe();
    this.subCancelarCola?.unsubscribe();
    if (this.subBrokCompaniaMercado) {
      this.subBrokCompaniaMercado.unsubscribe();
    }
    if (this.subtema) {
      this.subtema.unsubscribe();
    }
    if (this.metaApiOrdersTimeout) {
      clearTimeout(this.metaApiOrdersTimeout);
      this.metaApiOrdersTimeout = null;
    }
    if (this.subOrdenes) {
      this.subOrdenes.unsubscribe();
    }
    if (this.subTrades) {
      this.subTrades.unsubscribe();
    }
    if (this.subOrdenes && !this.subOrdenes.closed) {
      this.subOrdenes.unsubscribe();
    }
    if (this.idnectumsSubscription) {
      this.idnectumsSubscription.unsubscribe();
    }
    if (this.subPositions) {
      this.subPositions.unsubscribe();
    }
    this.margenWhatIfSub?.unsubscribe();
    this.stopMetaApiRealTimeCartera();
    if (this.subRealTimeWs) {
      this.subRealTimeWs.unsubscribe();
    }
    if (this.subHistoryDeals) {
      this.subHistoryDeals.unsubscribe();
    }
    this.cdr.detectChanges();

    if (this.brokerWindowRef && !this.brokerWindowRef.closed) {
      this.brokerWindowRef.close();
      this.brokerWindowRef = null;
    }
    localStorage.setItem('idcarterabroker', '0');

  }

  /** Polling loop for MetaAPI orders with rate-limit backoff */
  private startMetaApiPolling(): void {
    const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);
    const adapter   = this.brokerAdapterFactory.getAdapter(this.BrokoptimalWallet);
    let prevCount = -1;

    const scheduleNext = (delayMs: number) => {
      if (this.metaApiOrdersTimeout) clearTimeout(this.metaApiOrdersTimeout);
      this.metaApiOrdersTimeout = setTimeout(() => doPoll(), delayMs);
    };

    const doPoll = () => {
      if (this.subOrdenes) this.subOrdenes.unsubscribe();
      this.subOrdenes = adapter.getOrders(accountId).subscribe({
        next: (orders: BrokerOrder[]) => {
          this.handleApiError(true);
          if (!orders || orders.length === 0) {
            if (this.ordenesActuales.length > 0) {
              this.ordenesActuales = [];
              this._brokerService.updatecargarListas(true);
            }
            scheduleNext(15000);
            return;
          }

          const changed = orders.filter((o) => {
            const prev = this.ordenesActuales.find((p: any) => p.orderId === o.orderId);
            return !prev ||
              prev.status !== o.status ||
              prev.filledQuantity !== o.filledQuantity ||
              prev.lmt_price !== o.limitPrice ||
              prev.stop_price !== o.stopPrice;
          });

          orders.forEach(o => {
            const idx = this.ordenesActuales.findIndex((p: any) => p.orderId === o.orderId);
            const mapped: any = {
              orderId: o.orderId, account: accountId,
              status: o.status, filledQuantity: o.filledQuantity,
              totalSize: o.quantity, ticker: o.symbol,
              side: o.side, origOrderType: o.orderType,
              lmt_price: o.limitPrice ?? 0, stop_price: o.stopPrice ?? 0,
              remainingQuantity: o.quantity - o.filledQuantity
            };
            if (idx === -1) this.ordenesActuales.push(mapped);
            else this.ordenesActuales[idx] = mapped;
          });

          if (changed.length > 0) {
            const payload = changed.map(o => ({
              orderId: o.orderId, account: accountId,
              status: o.status, filledQuantity: o.filledQuantity,
              totalSize: o.quantity, ticker: o.symbol,
              side: o.side, origOrderType: o.orderType,
              lmt_price: o.limitPrice ?? 0, stop_price: o.stopPrice ?? 0,
              remainingQuantity: o.quantity - o.filledQuantity
            }));
            this._sseservice.apiPostNew('broker/necorders', payload, this.licencia).subscribe({
              next: (data: any) => {
                if (data?.nuevo > 0) this.getOptimalWallet(this.BrokoptimalWallet, true, false);
                this._brokerService.updatecargarListas(true);
              }
            });
          }

          if (orders.length !== prevCount) {
            prevCount = orders.length;
            this._brokerService.updatecargarListas(true);
          }

          scheduleNext(15000);
        },
        error: (err) => {
          const body = err?.error;
          if (body?.error === 'TooManyRequestsError') {
            const retryAt = new Date(body?.metadata?.recommendedRetryTime ?? Date.now() + 300000);
            const delayMs = Math.max(retryAt.getTime() - Date.now(), 60000);
            console.warn(`[MetaAPI] Rate limited on getOrders. Pausing ${Math.round(delayMs / 1000)}s`);
            scheduleNext(delayMs);
          } else {
            this.handleApiError(false);
            scheduleNext(15000);
          }
        }
      });
    };

    doPoll();

    this.startMetaApiDealsPolling(accountId, true);
  }

  private guardarDeals(accountId: string, deals: any[]): void {
    if (!deals || deals.length === 0) return;
    this._sseservice.apiPostNew('metaapi/history-deals/' + accountId, deals, this.licencia).subscribe({
      next: (res: any) => {
        if (res?.inserted > 0) {
          this.getOptimalWallet(this.BrokoptimalWallet, true, false);
          this._brokerService.updatecargarListas(true);
        }
      },
      error: (err: any) => console.error('[MetaAPI deals] error al guardar:', err)
    });
  }

  /**
   * Sondeo de cierres. `pasadaAmplia` lanza una única petición de 60 días antes de arrancar el
   * temporizador, para recuperar los cierres ocurridos mientras la sesión estaba cerrada; el
   * sondeo periódico usa una ventana corta porque a 5 s de cadencia pedir 60 días en cada vuelta
   * dispararía el rate limit.
   */
  private startMetaApiDealsPolling(accountId: string, pasadaAmplia: boolean): void {
    if (this.subHistoryDeals) this.subHistoryDeals.unsubscribe();

    if (pasadaAmplia) {
      const ahora = Date.now();
      this.metaApiService.getHistoryDeals(
        accountId,
        new Date(ahora - BrokerComponent.DEALS_VENTANA_AMPLIA_MS).toISOString(),
        new Date(ahora).toISOString()
      ).subscribe({
        next: (deals: any[]) => this.guardarDeals(accountId, deals),
        error: (err: any) => console.error('[MetaAPI] getHistoryDeals (pasada amplia) error:', err)
      });
    }

    //temporal 5000 por 60000
    this.subHistoryDeals = timer(0, 5000).subscribe(() => {
      const end = new Date().toISOString();
      const start = new Date(Date.now() - BrokerComponent.DEALS_VENTANA_SONDEO_MS).toISOString();
      this.metaApiService.getHistoryDeals(accountId, start, end).subscribe({
        next: (deals: any[]) => this.guardarDeals(accountId, deals),
        error: (err: any) => {
          // Un error ya no llega como lista vacía, así que aquí se distingue el rate limit de
          // un mercado sin cierres. Mismo tratamiento que en el sondeo de getOrders.
          const body = err?.error;
          if (body?.error === 'TooManyRequestsError') {
            const retryAt = new Date(body?.metadata?.recommendedRetryTime ?? Date.now() + 300000);
            const delayMs = Math.max(retryAt.getTime() - Date.now(), 60000);
            console.warn(`[MetaAPI] Rate limited on getHistoryDeals. Pausing ${Math.round(delayMs / 1000)}s`);
            this.subHistoryDeals?.unsubscribe();
            // Al reanudar se repite la pasada amplia: durante la pausa han podido cerrarse
            // operaciones que ya caen fuera de la ventana corta del sondeo.
            this.subHistoryDeals = timer(delayMs).subscribe(() => this.startMetaApiDealsPolling(accountId, true));
          } else {
            console.error('[MetaAPI] getHistoryDeals error:', err);
          }
        }
      });
    });
  }

  /** Precios en tiempo real (MetaAPI) para los activos de la pestaña Cartera.
   *  Llegan por el socket de MetaAPI (MetaApiStreamingService); si el socket cae, se vuelve a
   *  sondear getCurrentPrice cada 60 s hasta que se recupere.
   *  Cada precio se persiste en backend (POST metaapi/tiemporeal, que reenvía por ws/tiemporeal)
   *  como máximo una vez por minuto y por ISO.
   */
  private startMetaApiRealTimeCartera(): void {
    this.stopMetaApiRealTimeCartera();
    const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);
    if (accountId !== this.specsMetaApiCuenta) {
      // El mismo símbolo puede tener otro tamaño de contrato en otro bróker
      this.specsMetaApi.clear();
      this.specsMetaApiPedidas.clear();
      this.specsMetaApiCuenta = accountId;
    }
    this.metaApiStreaming.useAccount(accountId);
    this.subCarteraStreamStatus = this.metaApiStreaming.status$.subscribe(status => {
      if (status === 'down') this.startCarteraRestFallback(accountId);
      else if (status === 'synced') this.stopCarteraRestFallback();
    });
    this.syncCarteraStream();
  }

  private stopMetaApiRealTimeCartera(): void {
    this.subRealTimeCartera?.unsubscribe();
    this.subRealTimeCartera = null;
    this.subCarteraStreamStatus?.unsubscribe();
    this.subCarteraStreamStatus = null;
    this.stopCarteraRestFallback();
    this.carteraStreamKey = '';
  }

  /** (Re)suscribe al socket los ISOs de carterasmetaapi; no hace nada si la lista no cambió. */
  private syncCarteraStream(): void {
    if (!this.subCarteraStreamStatus) return;
    const isos: string[] = Array.from(new Set<string>((this.carterasmetaapi || []).map((t: any) => t?.iso).filter(Boolean)));
    const key = isos.map(i => i.toUpperCase()).sort().join(',');
    this.cargarSpecsCartera(isos);
    if (key === this.carteraStreamKey && this.subRealTimeCartera) return;
    this.carteraStreamKey = key;
    // Abrir antes de soltar: los ISOs que siguen no se desuscriben en MetaAPI.
    const previous = this.subRealTimeCartera;
    this.subRealTimeCartera = isos.length
      ? this.metaApiStreaming.prices$(isos, 1000).subscribe(price => this.aplicarPrecioCartera(price.symbol, price))
      : null;
    previous?.unsubscribe();
  }

  /**
   * Especificación (contractSize, tickSize) de cada símbolo de la cartera, una vez por símbolo y
   * cuenta: el beneficio de MetaTrader se calcula en lotes y necesita el tamaño del contrato.
   */
  private cargarSpecsCartera(isos: string[]): void {
    const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);
    if (!accountId) return;
    isos.forEach(iso => {
      const clave = iso.toUpperCase();
      if (this.specsMetaApi.has(clave) || this.specsMetaApiPedidas.has(clave)) return;
      this.specsMetaApiPedidas.add(clave);
      this.metaApiService.getSymbolSpecification(accountId, iso).subscribe({
        next: (spec: any) => {
          if (spec && this.specsMetaApiCuenta === accountId) this.specsMetaApi.set(clave, spec);
          else this.specsMetaApiPedidas.delete(clave); // se reintenta en la próxima sincronización
        },
        error: () => this.specsMetaApiPedidas.delete(clave)
      });
    });
  }

  /**
   * Beneficio de una posición MetaTrader como lo calcula MT5, en la divisa de la cuenta:
   * diferencia / tickSize × valor del tick × lotes (cantidadacciones son lotes, no unidades).
   * Sin valor del tick: diferencia × lotes × contractSize (divisa de cotización del símbolo).
   * Sin especificación todavía: la fórmula general, hasta que llegue.
   * Los cortos (bajista) cierran a ask y ganan cuando el precio baja.
   */
  private calcularBeneficioMetaTrader(position: any, price: any): { cotizacion: number; valorlatente: number; valorlatentepor: number } {
    const corto = !!position.bajista;
    const cotizacion = Number(corto ? (price.ask ?? price.bid) : (price.bid ?? price.ask));
    const entrada = Number(position.precioentradareal);
    const lotes = Math.abs(Number(position.cantidadacciones) || 0);
    const diff = (cotizacion - entrada) * (corto ? -1 : 1);
    const valorlatentepor = entrada > 0 ? diff / entrada * 100 : 0;

    const spec = this.specsMetaApi.get(String(position.compania ?? '').toUpperCase());
    const tickSize = Number(spec?.tickSize);
    const tickValue = Number(diff >= 0 ? price.profitTickValue : price.lossTickValue);
    let valorlatente: number;
    if (spec && tickSize > 0 && tickValue > 0) {
      valorlatente = diff / tickSize * tickValue * lotes;
    } else if (spec && Number(spec.contractSize) > 0) {
      valorlatente = diff * lotes * Number(spec.contractSize);
    } else {
      valorlatente = this.calculateValorLatente(position, cotizacion);
    }
    return { cotizacion, valorlatente, valorlatentepor };
  }

  private startCarteraRestFallback(accountId: string): void {
    if (this.subCarteraRestFallback) return;
    this.subCarteraRestFallback = timer(0, 60000).subscribe(() => {
      this.carterasmetaapi.forEach(tickett => {
        this.metaApiService.getCurrentPrice(accountId, tickett.iso).subscribe({
          next: (price: any) => { if (price) this.aplicarPrecioCartera(tickett.iso, price); },
          error: (err: any) => console.error(`[MetaAPI RT] precio error para ${tickett.iso}`, err)
        });
      });
    });
  }

  private stopCarteraRestFallback(): void {
    this.subCarteraRestFallback?.unsubscribe();
    this.subCarteraRestFallback = null;
  }

  /** Aplica un precio (del socket o del sondeo REST) a la cartera: backend, localStorage y posiciones. */
  private aplicarPrecioCartera(iso: string, price: any): void {
    const now = Date.now();
    if (now - (this.carteraUltimoPost.get(iso) ?? 0) >= 60000) {
      this.carteraUltimoPost.set(iso, now);
      this._sseservice.apiPostNew(`metaapi/tiemporeal/${encodeURIComponent(iso)}`, price, this.licencia).subscribe();
    }
    // Escribir en localStorage para que otros componentes (multicharts) consuman sin WS
    localStorage.setItem(`nec_rt_${iso}`, JSON.stringify({
      symbol: iso, bid: price.bid, ask: price.ask,
      cotizacion: price.bid, time: new Date().toISOString(), _ts: now
    }));
    // Actualizar posicionesModel directamente sin roundtrip por WS
    let updated = false;
    this.posicionesModel = this.posicionesModel.map((position: any) => {
      if (position.compania?.toUpperCase() !== iso.toUpperCase()) return position;
      updated = true;
      const { cotizacion, valorlatente, valorlatentepor } = this.calcularBeneficioMetaTrader(position, price);
      return {
        ...position,
        cotizacion,
        preciocierre: cotizacion,
        valorlatente,
        valorlatentepor,
        horaCotizacion: Math.floor(now / 1000)
      };
    });
    if (updated) {
      this._brokerService.updateBrokValPos(this.posicionesModel);
      this.cdr.detectChanges();
    }
  }

  tradesordenesTiempoReal() {
    // --- MetaAPI path ---
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      this.startMetaApiPolling();
      return;
    }

    // --- IBKR path (unchanged) ---
    let ordenesTemporales: OrdenBrokerInterface[] = [];

    this.subOrdenes = this.oauthService.fetchDataEverySecoundsbrk('/iserver/account/orders', 5000).subscribe({
      next: (data: any) => {
        this.handleApiError(true);
        //console.log("ordenes SUBORDENES:", data);
        let sumaactualordenes = 0;
        if (data) {
          if (data.orders.length > 0) {
            if (this.ordenesActuales.length == 0) {
              data.orders.forEach((nuevaOrden: OrdenBrokerInterface) => {
                console.log(nuevaOrden.account + " === " + this.BrokoptimalWallet.nombre);
                if (nuevaOrden.account === this.BrokoptimalWallet.nombre) {
                  this.ordenesActuales.push(nuevaOrden);
                  ordenesTemporales.push(nuevaOrden);
                }
              });
            } else {
              data.orders.forEach((nuevaOrden: OrdenBrokerInterface) => {
                const index = this.ordenesActuales.findIndex((orden: OrdenBrokerInterface) => orden.orderId === nuevaOrden.orderId);
                if (index !== -1) {// si existe el registro
                  if ((this.ordenesActuales[index].status !== nuevaOrden.status) && nuevaOrden.account === this.BrokoptimalWallet.nombre) {
                    this.ordenesActuales[index].status = nuevaOrden.status;
                    ordenesTemporales.push(nuevaOrden);
                    if (nuevaOrden.status === 'Filled') {
                      this.carteraComponent?.listaOrdenes?.consultarordenesalbroker();
                    }
                  }
                  if ((this.ordenesActuales[index].filledQuantity !== nuevaOrden.filledQuantity) && nuevaOrden.account === this.BrokoptimalWallet.nombre) {
                    this.ordenesActuales[index].filledQuantity = nuevaOrden.filledQuantity;
                    this.ordenesActuales[index].remainingQuantity = nuevaOrden.remainingQuantity;
                    ordenesTemporales.push(nuevaOrden);
                  }

                  if (this.ordenesActuales[index].origOrderType === 'LIMIT')
                    if ((this.ordenesActuales[index].lmt_price !== nuevaOrden.lmt_price) && nuevaOrden.account === this.BrokoptimalWallet.nombre) {
                      this.ordenesActuales[index].lmt_price = nuevaOrden.lmt_price;
                      ordenesTemporales.push(nuevaOrden);
                    }
                  if (this.ordenesActuales[index].origOrderType === 'STOP')
                    if ((this.ordenesActuales[index].stop_price !== nuevaOrden.stop_price) && nuevaOrden.account === this.BrokoptimalWallet.nombre) {
                      this.ordenesActuales[index].stop_price = nuevaOrden.stop_price;
                      ordenesTemporales.push(nuevaOrden);
                    }


                } else if (nuevaOrden.account === this.BrokoptimalWallet.nombre) {
                  this.ordenesActuales.push(nuevaOrden);
                  ordenesTemporales.push(nuevaOrden);
                }
              });
            }
            if (ordenesTemporales.length > 0) {
              this._sseservice.apiPostNew('broker/necorders', ordenesTemporales, this.licencia).subscribe({
                next: (data: any) => {
                  //                  console.log("broker/necorders response", data);
                  if (data.nuevo > 0) {
                    this.getOptimalWallet(this.BrokoptimalWallet, true, false);
                  }
                  this._brokerService.updatecargarListas(true);
                  ordenesTemporales = [];
                }
              });
            }
            if (this.contadosultimoordenes != data.orders.length) {
              this.contadosultimoordenes = data.orders.length;
              console.log("se reinicia contador ordenes");
              this._brokerService.updatecargarListas(true);
            }
            if (this.sumaprecioordees != sumaactualordenes) {
              this.sumaprecioordees = sumaactualordenes;
              console.log("se reinicia suma de precios de ordenes");
              this._brokerService.updatecargarListas(true);
            }
          }
        } else {
          console.log("Esta data es null: ", data);
          this._cookieService.delete('auth_broker');
        }
      }, error: (error) => {
        console.log("entre en NOTIFICAR CIERRE");
        // capturar si es error de conexion o red
        this.handleApiError(false);
      }
    });
    let tradersTemporales: TradeBrokerInterface[] = [];
    // days=7: sin parámetro IBKR solo devuelve las ejecuciones del día y las órdenes ejecutadas
    // con /broker cerrado no llegaban nunca a nectrades (ni a la reconciliación de estados).
    this.subTrades = this.oauthService.fetchDataEverySecoundsbrk('/iserver/account/trades?days=7', 5000).subscribe({
      next: (data: any) => {
        if (data) {
          if (data.length > 0) {
            if (this.contadortrades != data.length) {
              this.contadortrades = data.length;
              console.log("se reinicia contador trades");
              this.DataBroker();
            }
            if (this.tradersActuales.length === 0) {
              this.tradersActuales = data;
              tradersTemporales = data;
              console.log("se lleno tradersTemporales", tradersTemporales);
            } else {
              data.forEach((nuevoTrader: TradeBrokerInterface) => {
                const index = this.tradersActuales.findIndex((trader: TradeBrokerInterface) => trader.execution_id === nuevoTrader.execution_id);
                if (index === -1) {
                  this.tradersActuales.push(nuevoTrader);
                  tradersTemporales.push(nuevoTrader);
                }
              });
            }
          }
          if (tradersTemporales.length > 0) {
            this._sseservice.apiPostNew('broker/nectrades', tradersTemporales, this.licencia).subscribe({
              next: (data: any) => {
                console.log("RESPUESTA DESDE TRADERS: ", data.nuevo);
                if (data.nuevo > 0) {
                  this.getOptimalWallet(this.BrokoptimalWallet, true, false);
                }
                tradersTemporales = [];
                console.log("se vacia tradersTemporales", tradersTemporales);
              }
            });
          }
        } else {
          console.log("LA DATA ES NULL ", data);
          this._cookieService.delete('auth_broker');
        }
      }, error: (error) => {
        console.log("entre en NOTIFICAR CIERRE");

      }
    });
  }
  /** `manual`: pulsado "Forzar Entradas" (sincroniza también el diario); el temporizador llama sin él. */
  async valoresTiempoReal(manual: boolean = false) {
    if (this.actualizandoTiempoReal) return;
    // Con la automatización activa ya revisa el temporizador: forzar duplicaría la revisión
    if (manual && this.automatizado) {
      this.toastr.warning('Detenga la automatización para forzar entradas', 'Forzar Entradas');
      return;
    }
    this.actualizandoTiempoReal = true;
    if (manual) this.actualizandoTiempoRealManual = true;
    let operacionesTemporales: operationinterface[] = [];
    // if(this._cookieService.check('auto' + this.BrokoptimalWallet.idcartera) && this.estadoparaenviar.length > 0)
    //{
    // 
    // }
    console.log("Estado para enviar a modelo IA: ", this.estadoparaenviar);
    //if (this._cookieService.check('auto' + this.BrokoptimalWallet.idcartera) && this.estadoparaenviar.length > 0) {
      //this.toastr.error(this.estadoparaenviar);
    //}
    console.log(" dd " + this.revisandomodeloia);
    if (this.colaOrdenes.length == 0 && (manual || this.automatizado)) {
      let entradas = this.existemargen && this.existemargenbroker && this.existeriesgo;

      let mensageentradas = '';
      if (!this.existemargen) mensageentradas += ' - Margen Excedido ';
      if (!this.existemargenbroker) mensageentradas += ' - Margen Broker Excedido ';
      if (!this.existeriesgo) mensageentradas += ' - Riesgo Excedido ';
      if (mensageentradas.length > 0) mensageentradas += ' No se buscara entradas.';
      console.log("Entradas para revisar modelo IA: ", entradas, mensageentradas);

      if (this.revisandomodeloia) { this.actualizandoTiempoReal = false; this.actualizandoTiempoRealManual = false; return; }
      else this.revisandomodeloia = true;

      // Gateway MT5 con Algo Trading desactivado: revisarModeloBrokerIajava graba en tbl_operacion y
      // avanza el cursor de la suscripción, pero sus órdenes no se podrían enviar. No se revisa.
      if ((this.BrokoptimalWallet.tipoBroker ?? 'IBKR') === 'METAAPI' && this.metaApiService.isGateway()
          && !(await lastValueFrom(this.metaApiService.comprobarAlgoTrading()))) {
        if (!this.avisadoAlgoTradingOff) {
          this.avisadoAlgoTradingOff = true;
          const msj = 'Algo Trading está desactivado en MetaTrader 5: no se revisará el modelo ni se enviarán órdenes hasta que lo actives.';
          this.toastr.warning(msj, 'Algo Trading desactivado', { timeOut: 15000 });
          this.guardarNotificacion(new Notificacion('Algo Trading desactivado', msj, 'BROKER - ' + this.BrokoptimalWallet.nombre));
        }
        this.revisandomodeloia = false;
        this.actualizandoTiempoReal = false;
        this.actualizandoTiempoRealManual = false;
        return;
      }
      this.avisadoAlgoTradingOff = false;

      const candles = await this.actualizarCandlesAntesDeRevisarModelo(manual);
      if (!candles.ok) {
        this.revisandomodeloia = false;
        this.actualizandoTiempoReal = false;
        this.actualizandoTiempoRealManual = false;
        return;
      }
      if (candles.avisos.length > 0) {
        this.toastr.warning(
          `Sin entradas en este cierre para: ${candles.avisos.join(', ')}.`,
          'Velas incompletas o con retraso',
          { timeOut: 10000 }
        );
      }

      const tipoBroker = this.BrokoptimalWallet.tipoBroker ?? 'IBKR';
      const cuerpoRevision = JSON.stringify({
        idModelo: String(this.BrokoptimalWallet.idModelo),
        idcartera: String(this.BrokoptimalWallet.idcartera),
        entradas,
        tipoBroker,
        idNectumSinVelas: candles.idNectumSinVelas
      });
      const sincronizarCompleta = () => this.sincronizarCompletaTrasRevision(manual);
      this._sseservice.apiPostNew('broker/revisarModeloBrokerIajava', cuerpoRevision, this.licencia).subscribe({
        next: (data: any) => {
          if (data.operaciones) {
            if (data.operaciones.length > 0) {
              let contaoperacoin = 0;
              let totaloperaciones = data.operaciones.length;
              data.operaciones.forEach((operacion: operationinterface) => {
                const index = this.operacionesActuales.findIndex((ope: operationinterface) => ope.isooper === operacion.isooper && ope.tipoOperacion === operacion.tipoOperacion && ope.bajista === operacion.bajista && ope.idNectum === operacion.idNectum);
                let fechaMilisegundos = new Date().getTime();
                operacion.estado = 'PENDIENTE-ENVIO';
                if (index === -1 && operacion.tipoOperacion != 'ACTUALIZACION') {
                  operacionesTemporales.push(operacion);
                  this.operacionesActuales.push(operacion);
                  let ordersData = this.construirOrdersData(operacion, fechaMilisegundos);
                  // Forzadas sin automatización: la cola las envía igual que las de Sincronizar
                  if (manual) this.ordenesSincronizacion.add(ordersData.orders[0].cOID);
                  this.encolar(ordersData, manual ? 'FORZAR_ENTRADAS' : 'AUTOMATIZAR');
                  this.colaOrdenesService.updateColaOrdenes(this.colaOrdenes);
                  this.colaOrdenesService.setIdCartera(this.BrokoptimalWallet.idcartera);
                  console.log(" operacionesactuales " + this.operacionesActuales.length);

                } else {
                  console.log("Ya existe la operacion en la lista de operaciones actuales: ", operacion.isooper, operacion.tipoOperacion);
                }
                //si es la ultima iteracion del forEach, enviar las operaciones al broker                
                if (++contaoperacoin === totaloperaciones)
                  this.colaOrdenesService.updateOperaciones(this.operacionesActuales);
              });
              this.toastr.success(data.operaciones.length + " Nuevas operaciones generadas por el modelo suscrito");
              this.guardarNotificacion(new Notificacion('Nuevas operaciones generadas', data.operaciones.length + ' nuevas operaciones generadas por el modelo suscrito', 'BROKER - ' + this.BrokoptimalWallet.nombre));
            } else {
              this.toastr.error('No se generaron nuevas operaciones por el modelo suscrito', 'Aviso', { timeOut: 10000 });
              if (!data.status) {
                this.toastr.error(data.msg, 'Error', {
                  timeOut: 0,
                  extendedTimeOut: 0,
                  closeButton: true,
                  tapToDismiss: false,
                  disableTimeOut: true,
                  positionClass: 'toast-bottom-right'
                });
                this._cookieService.delete('auto' + this.BrokoptimalWallet.idcartera)
                this.colaOrdenesService.clearLocalStorageForCartera(this.BrokoptimalWallet.idcartera);
                this.guardarNotificacion(new Notificacion('Error revisando modelo IA', data.msg, 'BROKER - ' + this.BrokoptimalWallet.nombre));
              }
            }
          } else console.log('sin data');
          setTimeout(() => { this.revisandomodeloia = false; }, 5000);
          this.actualizandoTiempoReal = false;
          this.actualizandoTiempoRealManual = false;
        },
        complete: () => {
          setTimeout(() => { this.revisandomodeloia = false; }, 5000);
          this.actualizandoTiempoReal = false;
          this.actualizandoTiempoRealManual = false;
          sincronizarCompleta();
        },
        error: () => {
          this.toastr.error('Error de conexión revisando el modelo IA', 'Error', { timeOut: 10000 });
          this.guardarNotificacion(new Notificacion('Error de conexión', 'Error al revisar el modelo IA suscrito', 'BROKER - ' + this.BrokoptimalWallet.nombre));
          setTimeout(() => { this.revisandomodeloia = false; }, 5000);
          this.actualizandoTiempoReal = false;
          this.actualizandoTiempoRealManual = false;
          sincronizarCompleta();
        }
      });
    } else {
      //this.iniciarContadorRegresivo();
      if (manual) this.toastr.info('Hay órdenes en cola, espere a que se envíen', 'Forzar Entradas');
      this.actualizandoTiempoReal = false;
      this.actualizandoTiempoRealManual = false;
    }


  }

  private construirOrdersData(operacion: operationinterface, fechaMilisegundos: number = new Date().getTime(),
                              precioStopLoss: number = operacion.stoplossinicial): any {
    let side = 'BUY';
    let tipoOperacion = operacion.tipoOperacion;
    if (tipoOperacion === 'SALIDA') side = 'SELL';
    let bajistaStr = 'A';
    if (operacion.bajista) {
      bajistaStr = 'B';
      if (operacion.tipoOperacion === 'SELL') side = 'BUY';
      if (operacion.tipoOperacion === 'BUY') side = 'SELL';
    }
    const esApertura = (tipoOperacion === 'ENTRADA' && !operacion.bajista) || (tipoOperacion === 'SALIDA' && operacion.bajista);
    let tempconid = Number(operacion.conid);
    let tempsectype = operacion.secType;
    return {
      orders: [
        {
          orderType: 'MKT',
          ticker: operacion.nombreCompania.split(' CFD')[0],
          side: side,
          quantity: operacion.cantidadacciones,
          remainingquantity: operacion.cantidadacciones,
          acctId: this.BrokoptimalWallet.nombre,
          cOID: 'nctminvst' + fechaMilisegundos + operacion.idNectum + '-' + operacion.isooper + ':' + bajistaStr,
          secType: tempconid + ':' + tempsectype,
          filledquantity: 0,
          parentId: 'nctminvst' + fechaMilisegundos + operacion.idNectum + '-' + operacion.isooper + ':' + bajistaStr,
          tif: 'DAY',
          referrer: 'modelosdeinversion',
          useAdaptive: false,
          conid: tempconid,
          price: 0, idmodelo: operacion.idmodelo,
          carteraid: operacion.carteraid,
          subcarteraid: operacion.subcarteraid,
          // El backend calcula siempre el precio de SL/TP; solo se envían si el modelo los tiene activos
          ...(this.isOco && esApertura && operacion.stoplossactivo === true && precioStopLoss > 0
            ? { stopLoss: precioStopLoss } : {}),
          ...(this.isOco && esApertura && operacion.profitactivo === true && operacion['profit'] > 0
            ? { takeProfit: operacion['profit'] } : {}),
        }
      ]
    };
  }

  abrirSincronizarComparativa(): void {
    const dialogRef = this.dialog.open(SincronizarComparativaDialogComponent, {
      width: '90%', maxWidth: '1400px', maxHeight: '90vh', panelClass: this.theme,
      // Flotante sin backdrop (como el asistente de condiciones) para poder minimizarla y seguir usando /broker.
      hasBackdrop: false,
      data: {
        optimalWallet: this.BrokoptimalWallet,
        idcarterasuscrita: this.idcarterasuscrita,
        licencia: this.licencia,
        isDark: this.isDark,
        // Getter: el diálogo es no modal y el OCO puede cambiar mientras sigue abierto.
        getOco: () => this.isOco,
        setOco: (oco: boolean) => this.actualizarOco(oco)
      }
    });
    dialogRef.componentInstance.sincronizarOperaciones.subscribe((operacionesSeleccionadas: operationinterface[]) => {
      this.onSincronizarDesdeDialog(operacionesSeleccionadas);
    });
  }

  /** Mismo estado que el toggle "Ordenes oco" de SuscripcionesConfirmarComponent (isOco + localStorage). */
  private actualizarOco(oco: boolean): void {
    this.isOco = oco;
    localStorage.setItem('oco_' + this.BrokoptimalWallet.idcartera, String(oco));
    // Si la pestaña Control Operativa no está abierta no hay instancia: al crearse lee localStorage.
    if (this.suscripcionesConfirmar) this.suscripcionesConfirmar.isOco = oco;
  }

  /** Vista previa para forzar la salida (cierre directo en el broker, cancelando OCO) de las operaciones entradas. */
  abrirSalirFinDia(): void {
    // Con la automatización activa el modelo ya hace la salida de fin de día: cerrar a mano la duplicaría
    if (this.automatizado) {
      this.toastr.warning('Detenga la automatización antes de salir a fin de día', 'Salir fin de día');
      return;
    }
    // El diálogo cierra directo en el broker: no debe cruzarse con órdenes pendientes de la cola
    if (this.colaOrdenes.length > 0) {
      this.toastr.warning('Hay órdenes en cola, espere a que se envíen', 'Salir fin de día');
      return;
    }
    const dialogRef = this.dialog.open(SalirFinDiaDialogComponent, {
      width: '90%', maxWidth: '1100px', maxHeight: '90vh', panelClass: this.theme, disableClose: true,
      data: {
        optimalWallet: this.BrokoptimalWallet,
        idcarterasuscrita: this.idcarterasuscrita,
        licencia: this.licencia,
        isDark: this.isDark,
        automatizado: () => this.automatizado
      }
    });
    dialogRef.afterClosed().subscribe((huboCierres: boolean) => {
      if (!huboCierres) return;
      this._brokerService.updatecargarListas(true);
      this._brokerService.updateactualizarCarteraBroker(true);
    });
  }

  onSincronizarDesdeDialog(operaciones: operationinterface[]): void {
    if (!operaciones || operaciones.length === 0) return;
    // Con la automatización activa el bucle de envío competiría con estas órdenes (dobles envíos).
    if (this._cookieService.check('auto' + this.BrokoptimalWallet.idcartera)) {
      this.toastr.warning('Detenga la automatización de esta cartera antes de sincronizar operaciones', 'Sincronizar');
      return;
    }
    // MetaTrader sin Algo Trading: no se graban ni se encolan operaciones que no se pueden enviar
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      this.metaApiService.verificarAlgoTradingParaOperar().subscribe(activo => {
        if (activo) this.encolarSincronizacion(operaciones);
      });
      return;
    }
    this.encolarSincronizacion(operaciones);
  }

  private encolarSincronizacion(operaciones: operationinterface[]): void {
    let nuevas = 0;
    operaciones.forEach((operacion) => {
      const yaExiste = this.operacionesActuales.some(o =>
        o.isooper === operacion.isooper && o.tipoOperacion === operacion.tipoOperacion &&
        o.bajista === operacion.bajista && o.idNectum === operacion.idNectum);
      if (yaExiste) return;

      // Las filas del diálogo vienen de ia/crearmodelojava (idcartera nunca seteado, backtest a
      // nivel de modelo) o de posiciones.service.ts (idcartera hardcodeado a 0) — sin esto,
      // updateOperaciones() persiste con `operaciones[0].idcartera` mal y la operación nunca
      // aparece en /api/operaciones/{idcartera real}.
      operacion.idcartera = this.BrokoptimalWallet.idcartera;
      operacion.estado = 'PENDIENTE-ENVIO';
      // Las salidas sintéticas de "Cartera actual" vienen de posiciones.service.ts con fechaentrada
      // (yyyy-MM-dd, fecha de ENTRADA); el backend exige "yyyy-MM-dd HH:mm" y la salida ocurre ahora.
      if (!/\d{2}:\d{2}/.test(operacion.fechaOperacion ?? '')) {
        operacion.fechaOperacion = fechaOperacionBackend(fechaHoyIso());
      }
      // Ídem: traen tiporiesgo '' y el enum TipoRiesgo no acepta cadena vacía; sin el campo el
      // backend usa su valor por defecto (LIMITADO).
      if (!operacion.tiporiesgo) {
        delete (operacion as Partial<operationinterface>).tiporiesgo;
      }
      this.operacionesActuales.push(operacion);

      // El SL que muestra la tabla de Sincronizar es `stoploss` (nivel vigente, puede ser dinámico);
      // `stoplossinicial` queda como respaldo.
      const precioStopLoss = operacion['stoploss'] > 0 ? operacion['stoploss'] : operacion.stoplossinicial;
      // Las filas de Recalcular no traen stoplossinicial: sin él la operación quedaría sin SL que
      // establecer después desde la tabla (enviada sin OCO) y el riesgo de la cola sería el nominal.
      if (!(operacion.stoplossinicial > 0) && precioStopLoss > 0) operacion.stoplossinicial = precioStopLoss;
      const ordersData = this.construirOrdersData(operacion, undefined, precioStopLoss);
      console.log('[Sincronizar][OCO]', {
        isooper: operacion.isooper, tipoOperacion: operacion.tipoOperacion, bajista: operacion.bajista, isOco: this.isOco,
        stoplossactivo: operacion.stoplossactivo, profitactivo: operacion.profitactivo,
        stoploss: operacion['stoploss'], stoplossinicial: operacion.stoplossinicial, profit: operacion['profit'],
        stopLossEnviado: ordersData.orders[0].stopLoss, takeProfitEnviado: ordersData.orders[0].takeProfit
      });
      this.ordenesSincronizacion.add(ordersData.orders[0].cOID);
      this.encolar(ordersData, 'SINCRONIZAR');
      nuevas++;
    });
    if (nuevas === 0) {
      this.toastr.info('Las operaciones seleccionadas ya estaban encoladas', 'Sincronizar');
      return;
    }
    this.colaOrdenesService.updateColaOrdenes(this.colaOrdenes);
    this.colaOrdenesService.setIdCartera(this.BrokoptimalWallet.idcartera);
    this.colaOrdenesService.updateOperaciones(this.operacionesActuales);
    this.toastr.success(`${nuevas} operación(es) enviándose al broker`, 'Sincronizar');
  }

  /**
   * Las órdenes automáticas no se envían con el mercado cerrado: se descartan (una señal a
   * mercado ya no es válida en la apertura siguiente) y su operación queda en BROKER-CERRADO.
   * Con horario desconocido se envía igual, salvo que IBKR ya haya respondido "Exchange is
   * closed" (brokerOpen), que se rearma en cuanto el horario confirma el mercado abierto.
   */
  private enviarSiMercadoAbierto(ordersData: any) {
    if (this.verificandoHorarioCola) return;
    const cOID: string = ordersData?.orders?.[0]?.cOID ?? '';
    const isooper = isooperDeOrderRef(cOID);
    const operacion = this.operacionesActuales.find(ope => ope.isooper === isooper);

    this.verificandoHorarioCola = true;
    this.brokerTimeService.getMarketSchedule(operacion?.idNectum, this.BrokoptimalWallet).subscribe({
      next: schedule => {
        this.verificandoHorarioCola = false;
        if (this.colaOrdenes[0] !== ordersData) return; // la cola cambió mientras se consultaba
        const { estado } = this.brokerTimeService.estadoMercado(schedule);
        if (estado === 'CERRADO') {
          const msj = `Orden de ${operacion?.nombreCompania ?? isooper} descartada: el mercado está cerrado.`;
          this.descartarOrden(ordersData, 'BROKER-CERRADO', 'Orden descartada: mercado cerrado', msj);
          return;
        }
        if (estado === 'ABIERTO') this.brokerOpen = true;
        if (this.brokerOpen) this.crearordenbroker(ordersData, this.licencia);
        else this.checkAndUpdateEstado();
      },
      error: () => { this.verificandoHorarioCola = false; }
    });
  }

  /** Saca la orden de la cola sin enviarla y deja su operación en `estado` (BROKER-CERRADO, ALGO-TRADING-OFF). */
  private descartarOrden(ordersData: any, estado: string, titulo: string, msj: string) {
    const index = this.colaOrdenes.indexOf(ordersData);
    if (index > -1) {
      this.colaOrdenes.splice(index, 1);
      this.colaOrdenesService.updateColaOrdenes(this.colaOrdenes);
    }
    this._sseservice.apiPostNew('actualizarEstadoOperacionesOrdenes', { estado, ordenes: [ordersData] }, this.licencia).subscribe();
    this.toastr.warning(msj, titulo, { timeOut: 10000 });
    this.guardarNotificacion(new Notificacion(titulo, msj, 'BROKER - ' + this.BrokoptimalWallet.nombre));
  }

  crearordenbroker(ordersData: any, licencia: string) {
    console.log("this.ordersData.orders[0].cOID ", ordersData);
    let dataorden = ordersData;

    const order = dataorden?.orders?.[0] ?? null;
    const retryKey = order ? String(order.conid ?? order.ticker ?? order.cOID ?? 'unknown') : 'unknown';
    const removeCurrentOrder = () => {
      const index = this.colaOrdenes.indexOf(ordersData);
      if (index > -1) {
        this.colaOrdenes.splice(index, 1);
        this.colaOrdenesService.updateColaOrdenes(this.colaOrdenes);
      }
      // MetaTrader: la siguiente orden sale ya, sin esperar al tick de 3 s (el espacio entre envíos
      // lo garantiza el turno de /trade de MetaApiService). IBKR mantiene el ritmo del tick.
      if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI' && this.colaOrdenes.length > 0) {
        setTimeout(() => this.procesarCola());
      }
    };

    // --- MetaAPI path: no whatif / no reply, place order directly ---
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      const metaOrder = ordersData?.orders?.[0];
      if (!metaOrder) { removeCurrentOrder(); return; }
      // La cola se reintenta cada 3 s y la orden sigue en ella mientras MetaAPI responde: sin esta
      // marca, un /trade lento se reenvía y cada reenvío es otra compra.
      const claveEnvio = String(metaOrder.cOID ?? '');
      if (this.envioEnCurso.has(claveEnvio)) return;
      this.envioEnCurso.add(claveEnvio);
      const liberarEnvio = () => this.envioEnCurso.delete(claveEnvio);
      const quitarOrdenMeta = () => { liberarEnvio(); removeCurrentOrder(); };
      const cierreMeta = this.operacionDeCierre(metaOrder);
      if (cierreMeta) {
        this.cerrarPosicionMetaApiAutomatica(ordersData, cierreMeta, licencia, quitarOrdenMeta, liberarEnvio);
        return;
      }
      const side: string = (metaOrder.side ?? '').toUpperCase();
      const otype: string = (metaOrder.orderType ?? 'MKT').toUpperCase();
      let actionType: string;
      if (side === 'BUY') {
        actionType = otype === 'LMT' ? 'ORDER_TYPE_BUY_LIMIT'
                   : otype === 'STP' ? 'ORDER_TYPE_BUY_STOP'
                   : 'ORDER_TYPE_BUY';
      } else {
        actionType = otype === 'LMT' ? 'ORDER_TYPE_SELL_LIMIT'
                   : otype === 'STP' ? 'ORDER_TYPE_SELL_STOP'
                   : 'ORDER_TYPE_SELL';
      }
      const trade: any = {
        actionType,
        symbol: metaOrder.ticker,
        volume: Math.abs(Number(metaOrder.quantity ?? 1)),
      };
      if (otype !== 'MKT') {
        const px = metaOrder.price ?? metaOrder.lmtPrice ?? metaOrder.auxPrice;
        if (px) trade.openPrice = Number(px);
      }
      if (metaOrder.auxPrice && otype === 'STP') trade.openPrice = Number(metaOrder.auxPrice);
      if (metaOrder.stopLoss)   trade.stopLoss   = Number(metaOrder.stopLoss);
      if (metaOrder.takeProfit) trade.takeProfit = Number(metaOrder.takeProfit);
      const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);

      // Handlers del placeOrder — declarados antes de doPlaceOrder para evitar TDZ
      const PERMANENT_RETCODES = new Set([
        'TRADE_RETCODE_REJECT',
        'TRADE_RETCODE_CANCEL',
        'TRADE_RETCODE_INVALID',
        'TRADE_RETCODE_INVALID_VOLUME',
        'TRADE_RETCODE_INVALID_PRICE',
        'TRADE_RETCODE_INVALID_STOPS',
        'TRADE_RETCODE_TRADE_DISABLED',
        'TRADE_RETCODE_NO_MONEY',
        'TRADE_RETCODE_INVALID_EXPIRATION',
        'TRADE_RETCODE_SERVER_DISABLES_AT',
        'TRADE_RETCODE_CLIENT_DISABLES_AT',
        'TRADE_RETCODE_FROZEN',
        'TRADE_RETCODE_INVALID_FILL',
        'TRADE_RETCODE_ONLY_REAL',
        'TRADE_RETCODE_LIMIT_ORDERS',
        'TRADE_RETCODE_LIMIT_VOLUME',
        'TRADE_RETCODE_INVALID_ORDER',
        'TRADE_RETCODE_POSITION_CLOSED',
        'TRADE_RETCODE_LONG_ONLY',
        'TRADE_RETCODE_SHORT_ONLY',
        'TRADE_RETCODE_CLOSE_ONLY',
      ]);
      // Rechazos en los que MetaTrader garantiza que no se ejecutó nada: se pueden reintentar.
      const RETRY_SAFE_RETCODES = new Set([
        'TRADE_RETCODE_REQUOTE',
        'TRADE_RETCODE_PRICE_CHANGED',
        'TRADE_RETCODE_PRICE_OFF',
      ]);
      // Resultado desconocido (timeout, corte, error HTTP): la orden pudo ejecutarse, así que no se
      // reintenta; se saca de la cola y se pide revisar la posición en MetaTrader.
      const resultadoIncierto = (detalle: string) => {
        quitarOrdenMeta();
        const msj = `No se pudo confirmar la orden de ${metaOrder.ticker} (${detalle}). No se reintentará: revise en MetaTrader si se ejecutó.`;
        this.toastr.error(msj, 'Orden sin confirmar', { timeOut: 0, closeButton: true, positionClass: 'toast-top-center' });
        this.guardarNotificacion(new Notificacion('Orden MetaAPI sin confirmar', msj, 'BROKER - ' + this.BrokoptimalWallet.nombre));
      };
      const placeNext = (resp: any) => {
        if (resp?.error) {
          const httpErr = resp.error;
          const msg = httpErr?.error?.message ?? httpErr?.message ?? JSON.stringify(httpErr);
          const errorClass = httpErr?.error?.error;
          resultadoIncierto('MetaAPI error: ' + translateMetaApiHttpError(errorClass, msg));
          return;
        }
        // MetaAPI returns stringCode; only TRADE_RETCODE_DONE (10009) means success
        if (resp?.stringCode && resp.stringCode !== 'TRADE_RETCODE_DONE') {
          const msg = translateMetaApiError(resp.stringCode, resp.message);
          if (PERMANENT_RETCODES.has(resp.stringCode)) {
            this.toastr.error('MetaAPI: ' + msg + ' (' + resp.stringCode + ')', 'Error', { timeOut: 30000 });
            quitarOrdenMeta();
          } else if (RETRY_SAFE_RETCODES.has(resp.stringCode)) {
            this.toastr.warning('MetaAPI: ' + msg + ' (' + resp.stringCode + '). Se reintentará.', 'Aviso', { timeOut: 10000 });
            liberarEnvio();
          } else {
            resultadoIncierto(msg + ' (' + resp.stringCode + ')');
          }
          return;
        }
        console.log('MetaAPI placeOrder response', resp);
        // Ejecutada: fuera de la cola ya, antes de registrarla, para que un fallo del registro no la reenvíe.
        quitarOrdenMeta();
        const ordersWithAccount = ordersData.orders.map((o: any) => ({ ...o,
          acctid: accountId,
          orderId: resp.orderId ?? 0,
          status: 'Submitted',
          quantity: metaOrder.quantity,
        }));
        // Registros sintéticos STP/LMT para OCO MetaAPI — necesarios para confirmar
        const exitSideOco = side === 'BUY' ? 'SELL' : 'BUY';
        const syntheticExits: any[] = [];
        if (metaOrder.stopLoss > 0) {
          syntheticExits.push({
            cOID: metaOrder.cOID + '-SL', parentId: metaOrder.cOID,
            orderType: 'STP', side: exitSideOco,
            price: Number(metaOrder.stopLoss),
            quantity: metaOrder.quantity, ticker: metaOrder.ticker,
            conid: metaOrder.conid ?? 0, secType: metaOrder.secType,
            acctId: metaOrder.acctId, acctid: metaOrder.acctId,
            orderId: 0, status: 'Submitted', tif: 'GTC',
            carteraid: metaOrder.carteraid, subcarteraid: metaOrder.subcarteraid,
            idmodelo: metaOrder.idmodelo,
          });
        }
        if (metaOrder.takeProfit > 0) {
          syntheticExits.push({
            cOID: metaOrder.cOID + '-TP', parentId: metaOrder.cOID,
            orderType: 'LMT', side: exitSideOco,
            price: Number(metaOrder.takeProfit),
            quantity: metaOrder.quantity, ticker: metaOrder.ticker,
            conid: metaOrder.conid ?? 0, secType: metaOrder.secType,
            acctId: metaOrder.acctId, acctid: metaOrder.acctId,
            orderId: 0, status: 'Submitted', tif: 'GTC',
            carteraid: metaOrder.carteraid, subcarteraid: metaOrder.subcarteraid,
            idmodelo: metaOrder.idmodelo,
          });
        }
        this._sseservice.apiPostNew('broker/orderNuevo', this.conOrigen([...ordersWithAccount, ...syntheticExits], ordersData), licencia).subscribe({
          next: () => {
            this._brokerService.updatecargarListas(true);
            this.ordenPendiente = false;
          },
          error: () => this.avisarOrdenNoRegistrada(metaOrder.ticker)
        });
      };
      const placeError = (err: any) => {
        console.error('MetaAPI placeOrder error', err);
        const msg = err?.error?.message ?? err?.message ?? JSON.stringify(err);
        const errorClass = err?.error?.error;
        resultadoIncierto('Error al enviar orden MetaAPI: ' + translateMetaApiHttpError(errorClass, msg));
      };

      // Validar stop loss contra cotización actual antes de enviar
      // Con Algo Trading desactivado en el Gateway MT5 la orden no se puede enviar: se descarta
      // (como con el mercado cerrado) en vez de dejar la operación en PENDIENTE-ENVIO.
      const doPlaceOrder = () => {
        this.metaApiService.comprobarAlgoTrading().subscribe(activo => {
          if (!activo) {
            liberarEnvio();
            const msj = `Orden de ${metaOrder.ticker} descartada: Algo Trading está desactivado en MetaTrader 5.`;
            this.descartarOrden(ordersData, 'ALGO-TRADING-OFF', 'Orden descartada: Algo Trading desactivado', msj);
            return;
          }
          this.brokerAdapterFactory.getAdapter(this.BrokoptimalWallet).placeOrder(accountId, trade).subscribe({
            next: placeNext,
            error: placeError
          });
        });
      };

      if (trade.stopLoss) {
        // Si el socket ya tiene el precio del símbolo se evita la llamada REST.
        const streamed = this.metaApiStreaming.lastPrice(metaOrder.ticker);
        (streamed ? of(streamed) : this.metaApiService.getCurrentPrice(accountId, metaOrder.ticker)).subscribe({
          next: (priceData: any) => {
            if (priceData) {
              const bid = Number(priceData.bid ?? priceData.ask);
              const ask = Number(priceData.ask ?? priceData.bid);
              const sl  = trade.stopLoss;
              const invalidBuy  = side === 'BUY'  && sl >= ask;
              const invalidSell = side === 'SELL' && sl <= bid;
              if (invalidBuy || invalidSell) {
                const cotizacion = side === 'BUY' ? ask : bid;
                this.toastr.error(
                  `Stop Loss inválido para ${metaOrder.ticker}: el SL (${sl}) debe estar ${side === 'BUY' ? 'por debajo' : 'por encima'} de la cotización actual (${cotizacion.toFixed(5)}). Revise el SL configurado en el modelo.`,
                  'Orden cancelada — Stop Loss inválido',
                  { timeOut: 0, closeButton: true, positionClass: 'toast-top-center' }
                );
                quitarOrdenMeta();
                return;
              }
            }
            doPlaceOrder();
          },
          error: () => doPlaceOrder()
        });
      } else {
        doPlaceOrder();
      }
      return;
    }

    console.log("listaordenes broker ");
    console.log(this.listaOrdenesBroker);
    let conid = ordersData.orders[0].conid;
    let bajista = ordersData.orders[0].cOID.includes(':B') || ordersData.orders[0].cOID.includes(':b') ? true : false;
    const newIsooper = isooperDeOrderRef(ordersData.orders[0].cOID);
    //pendiente de ejecucion el broker///// pendingsubmite.. presubmiteed,
    //ejecutada o cancelada  // filled, cancelled, inactive, sincro
    for (let i = 0; i < this.listaOrdenesBroker.length; i++) {
      const existingIsooper = isooperDeOrderRef(this.listaOrdenesBroker[i].order_ref);
      // Las STP/LMT del OCO no son una orden duplicada: la salida las cancela antes de enviarse
      const tipoExistente = String(this.listaOrdenesBroker[i].orderType ?? '').toUpperCase();
      if (['STP', 'STOP', 'LMT', 'LIMIT'].includes(tipoExistente)) continue;
      if (this.listaOrdenesBroker[i].conid === conid && this.listaOrdenesBroker[i].bajista === bajista && existingIsooper === newIsooper && (this.listaOrdenesBroker[i].status === 'PendingSubmit' || this.listaOrdenesBroker[i].status === 'PreSubmitted' || this.listaOrdenesBroker[i].status === 'Submitted' || this.listaOrdenesBroker[i].status === 'PendingSubmit')) {
        console.log("Ya existe una orden para este conid y mismo tipo de orden " + ordersData.orders[0].cOID);
        return;
      }
    }
    console.log(new Date().toLocaleTimeString());

    // OCO bracket: añadir órdenes hijas STP y LMT para órdenes de entrada
    const entryOrder = ordersData.orders[0];
    const exitSide = entryOrder.side === 'BUY' ? 'SELL' : 'BUY';

    // Ajuste al tick antes de enviar a IBKR. El modelo guarda stoplossinicial/profit con precisión
    // completa a propósito (es la referencia de riesgo del backtest: alimenta cantidadacciones y
    // riesgooperacion), así que el redondeo al tick del instrumento se hace aquí, en la petición.
    // Se aplica sobre entryOrder porque las hijas STP/LMT leen sus precios de él.
    const tickDecimals = String(entryOrder.secType ?? '').split(':')[1] === 'CFD' ? 5 : 2;
    const aTick = (v: any) => Number(Number(v).toFixed(tickDecimals));
    if (entryOrder.stopLoss > 0)   entryOrder.stopLoss   = aTick(entryOrder.stopLoss);
    if (entryOrder.takeProfit > 0) entryOrder.takeProfit = aTick(entryOrder.takeProfit);

    if (entryOrder.stopLoss > 0) {
      ordersData.orders.push({
        cOID:         entryOrder.cOID + '-SL',
        parentId:     entryOrder.cOID,
        orderType:    'STP',
        side:         exitSide,
        auxPrice:     entryOrder.stopLoss,
        price:        entryOrder.stopLoss,
        quantity:     entryOrder.quantity,
        remainingquantity: entryOrder.quantity,
        filledquantity: 0,
        tif:          'GTC',
        conid:        entryOrder.conid,
        secType:      entryOrder.secType,
        acctId:       entryOrder.acctId,
        referrer:     'modelosdeinversion',
        useAdaptive:  false,
        idmodelo:     entryOrder.idmodelo,
        carteraid:    entryOrder.carteraid,
        subcarteraid: entryOrder.subcarteraid,
      });
    }
    if (entryOrder.takeProfit > 0) {
      ordersData.orders.push({
        cOID:         entryOrder.cOID + '-TP',
        parentId:     entryOrder.cOID,
        orderType:    'LMT',
        side:         exitSide,
        price:        entryOrder.takeProfit,
        quantity:     entryOrder.quantity,
        remainingquantity: entryOrder.quantity,
        filledquantity: 0,
        tif:          'GTC',
        conid:        entryOrder.conid,
        secType:      entryOrder.secType,
        acctId:       entryOrder.acctId,
        referrer:     'modelosdeinversion',
        useAdaptive:  false,
        idmodelo:     entryOrder.idmodelo,
        carteraid:    entryOrder.carteraid,
        subcarteraid: entryOrder.subcarteraid,
      });
    }

    if (this.whatIfInFlight) {
      console.log('Solicitud what-if aún en curso, se omite nuevo intento');
      return;
    }

    // Salida: cancelar antes el SL/TP (OCO) vivo; si no se puede, no se envía la salida
    const cierre = this.operacionDeCierre(entryOrder);
    if (cierre && !this.ocoCancelado.has(entryOrder.cOID)) {
      this.cancelarOcoAutomatica(ordersData, cierre, licencia, removeCurrentOrder);
      return;
    }

    // whatIfInFlight se libera al responder el what-if, pero la orden sigue en la cola hasta que
    // responde el POST /orders: sin esta marca, el tick de 3 s la reenvía mientras tanto.
    const claveEnvio = String(entryOrder.cOID ?? '');
    if (this.envioEnCurso.has(claveEnvio)) return;
    this.envioEnCurso.add(claveEnvio);
    const liberarEnvio = () => this.envioEnCurso.delete(claveEnvio);
    const quitarOrden = () => { liberarEnvio(); removeCurrentOrder(); };

    this.whatIfInFlight = true;

    this.oauthService.apiPostIbrk('/iserver/account/' + this.BrokoptimalWallet.nombre + '/orders/whatif', dataorden).subscribe({
      next: (data: any) => {
        console.log("respuesta whatif", data);
        this.whatIfRetryCount.delete(retryKey);
        this._sseservice.apiPostNew('broker/guardarWhatIf', { whatIf: data, conid: dataorden.orders[0].conid, cuenta: this.BrokoptimalWallet.nombre, cOID: dataorden.orders[0].cOID }, this.licencia).subscribe({
          next: (data: any) => {
            this._sseservice.apiPostNew('broker/orderNuevo', this.conOrigen(dataorden.orders, ordersData), licencia).toPromise()
              .then(response => {
                console.log(response)
                if (response.status) {
                  this.enviarOrdenBroker('/iserver/account/' + this.BrokoptimalWallet.nombre + '/orders ', dataorden, quitarOrden, liberarEnvio);
                } else {
                  quitarOrden();
                }
              }).catch(error => {
                // Aún no se envió nada a IBKR: se puede reintentar.
                liberarEnvio();
                this.toastr.error('Hubo un error ' + error.message, 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
              });

          },
          error: () => liberarEnvio()
        });

      }, error: (error) => {
        const maxAttempts = 3;
        const attempts = (this.whatIfRetryCount.get(retryKey) ?? 0) + 1;
        const symbolLabel = order?.ticker ?? order?.symbol ?? order?.cOID ?? order?.conid ?? 'esta compañía';
        this.whatIfRetryCount.set(retryKey, attempts);

        if (attempts >= maxAttempts) {
          console.warn(`What-if failed ${attempts} times for ${retryKey}. Skipping order.`);
          this.toastr.error(`What-if falló ${maxAttempts} veces para ${symbolLabel}. Se omitirá la orden.`, 'Orden omitida', {
            timeOut: 4000,
            extendedTimeOut: 0,
          });
          this.whatIfRetryCount.delete(retryKey);
          this.whatIfInFlight = false;
          quitarOrden();
          this.checkAndUpdateEstado();
          return;
        }
        liberarEnvio();

        if (this.isTimeoutError(error)) {
          console.warn('IBKR whatif timeout, retrying in 5 seconds');
          this.toastr.error('Tiempo de espera excedido. Reintentando en 5 segundos.', 'Orden en curso', {
            timeOut: 1000,
            extendedTimeOut: 0,
          });
          this.whatIfInFlight = false;
          setTimeout(() => this.crearordenbroker(ordersData, licencia), 5000);
          return;
        }
        this.whatIfInFlight = false;
        this.toastr.error('Error al crear la orden: ' + error.message, 'Error', {
          timeOut: 0,
          extendedTimeOut: 0,
        });
      },
      complete: () => {
        this.whatIfInFlight = false;
      }
    });
  }

  private isTimeoutError(error: any): boolean {
    if (!error) {
      return false;
    }

    const payload = error.error ?? error;

    if (typeof payload === 'string') {
      const trimmed = payload.trim();
      if (trimmed.toUpperCase() === 'TIMEOUT') {
        return true;
      }
      try {
        const parsed = JSON.parse(trimmed);
        if (parsed?.error === 'TIMEOUT') {
          return true;
        }
      } catch {
        return trimmed.toUpperCase().includes('TIMEOUT');
      }
    }

    if (payload && typeof payload === 'object') {
      if (payload.error === 'TIMEOUT') {
        return true;
      }
      const payloadMessage = (payload.message ?? '').toString().toUpperCase();
      if (payloadMessage.includes('TIMEOUT')) {
        return true;
      }
    }

    const message = (error.message ?? '').toString().toUpperCase();
    return message.includes('TIMEOUT');
  }

  /**
   * Datos de la operación si la orden de la cola cierra una posición (mismo criterio que
   * `esApertura` en construirOrdersData: alcista cierra vendiendo, bajista cierra comprando).
   */
  private operacionDeCierre(order: any): { isooper: string; conid: number; bajista: boolean; nombreCompania: string } | null {
    const cOID: string = order?.cOID ?? '';
    const bajista = /:B/i.test(cOID);
    const side = String(order?.side ?? '').toUpperCase();
    const esCierre = (side === 'SELL' && !bajista) || (side === 'BUY' && bajista);
    if (!esCierre) return null;
    return {
      isooper: isooperDeOrderRef(cOID),
      conid: Number(order.conid),
      bajista,
      nombreCompania: order.ticker ?? '',
    };
  }

  /** IBKR: cancela el OCO de una salida automática y reintenta crearordenbroker; 3 fallos descartan la orden. */
  private cancelarOcoAutomatica(ordersData: any, cierre: any, licencia: string, removeCurrentOrder: () => void) {
    if (this.cancelandoOco) return;
    const cOID: string = ordersData.orders[0].cOID;
    this.cancelandoOco = true;
    this.salidaService.cancelarOco(cierre, this.BrokoptimalWallet, licencia).subscribe({
      next: () => {
        this.cancelandoOco = false;
        this.cancelarOcoRetryCount.delete(cOID);
        this.ocoCancelado.add(cOID);
        this.crearordenbroker(ordersData, licencia);
      },
      error: (err: any) => {
        this.cancelandoOco = false;
        const intentos = (this.cancelarOcoRetryCount.get(cOID) ?? 0) + 1;
        const detalle = err?.error?.message ?? err?.message ?? String(err);
        if (intentos >= 3) {
          this.cancelarOcoRetryCount.delete(cOID);
          removeCurrentOrder();
          const msj = `Salida de ${cierre.nombreCompania} descartada: no se pudo cancelar su SL/TP en el broker (${detalle}).`;
          this.toastr.error(msj, 'Error cancelando SL/TP', { timeOut: 0, closeButton: true });
          this.guardarNotificacion(new Notificacion('Salida descartada', msj, 'BROKER - ' + this.BrokoptimalWallet.nombre));
          return;
        }
        this.cancelarOcoRetryCount.set(cOID, intentos);
        this.toastr.warning(`No se pudo cancelar el SL/TP de ${cierre.nombreCompania} (intento ${intentos}/3): ${detalle}`, 'Salida en espera', { timeOut: 5000 });
      }
    });
  }

  /** MetaAPI: la salida automática cierra por positionId (el broker elimina su SL/TP con la posición). */
  private cerrarPosicionMetaApiAutomatica(ordersData: any, cierre: any, licencia: string, removeCurrentOrder: () => void, liberarEnvio: () => void) {
    if (this.cancelandoOco) { liberarEnvio(); return; }
    this.cancelandoOco = true;
    const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);
    this.salidaService.cerrarPosicionMetaApi(cierre, this.BrokoptimalWallet, licencia).subscribe({
      next: (res: any) => {
        this.cancelandoOco = false;
        // Cerrada: fuera de la cola ya, para que un fallo del registro no repita el cierre.
        removeCurrentOrder();
        const registros = ordersData.orders.map((o: any) => ({ ...o,
          acctid: accountId,
          // positionId (no el ticket de cierre): así el backend reconoce esta salida al procesar el deal
          orderId: res.positionId,
          status: 'Submitted',
        }));
        this._sseservice.apiPostNew('broker/orderNuevo', this.conOrigen(registros, ordersData), licencia).subscribe({
          next: () => {
            this._brokerService.updatecargarListas(true);
            this.ordenPendiente = false;
          },
          error: () => this.avisarOrdenNoRegistrada(cierre.nombreCompania ?? ordersData.orders[0]?.ticker)
        });
      },
      error: (err: any) => {
        this.cancelandoOco = false;
        const msg = err?.error?.message ?? err?.message ?? String(err);
        this.toastr.error(`Salida de ${cierre.nombreCompania} descartada: ${translateMetaApiHttpError(err?.error?.error, msg)}`, 'Error MetaAPI', { timeOut: 30000 });
        removeCurrentOrder();
      }
    });
  }

  /** La orden se ejecutó en MetaAPI pero el backend no la guardó: no se reenvía, se avisa. */
  private avisarOrdenNoRegistrada(nombre: string) {
    const msj = `La orden de ${nombre} se ejecutó en MetaAPI pero no se pudo registrar. No se reenviará: sincronice la cartera.`;
    this.toastr.error(msj, 'Orden no registrada', { timeOut: 0, closeButton: true, positionClass: 'toast-top-center' });
    this.guardarNotificacion(new Notificacion('Orden MetaAPI no registrada', msj, 'BROKER - ' + this.BrokoptimalWallet.nombre));
  }

  handleListaOrdenesBroker(orders: any[]) {
    this.listaOrdenesBroker = orders;
  }
  /**
   * POST /orders de IBKR. `quitarOrden` saca la orden de la cola y libera su marca de envío;
   * `liberarEnvio` solo libera la marca (la orden sigue en cola y se reintentará).
   */
  enviarOrdenBroker(url: any, ordersData: any, quitarOrden: () => void, liberarEnvio: () => void) {
    console.log(url);
    console.log(ordersData);
    this.ordenPendiente = true;
    if (!this.apiIbkrAvailable) liberarEnvio();
    else
      this.oauthService.apiPostIbrk(url, ordersData).subscribe({
        next: (data: any) => {
          quitarOrden();

          console.log("ESTO RESPONDE BROKER", data);
          if (data) {
            if (data[0]) {
              if (data[0].message) {
                this.confirmarOp(data[0].id);
                this._brokerService.updatecargarListas(true);
              } else if (data[0].order_status == 'Submitted' || data[0].order_status == 'PreSubmitted' || data[0].order_status == 'PendingSubmit' || data[0].order_status == 'Filled' || data[0].order_status == 'Cancelled') {//PreSubmitted, PendingSubmit, Filled, Cancelled
                //enviar de la orden para actualizar en la base de datos
                this._sseservice.apiPostNew('broker/actualizarOrden', data, this.licencia).subscribe({
                  next: (data: any) => {
                    if (data.status) {
                      this._brokerService.updatecargarListas(true);
                      this.ordenPendiente = false;
                    }
                  }
                });
              }
            } else {
              console.log(data);
            }
          } else if (data.error) {
            let msj = data.cqe.post_payload.rejections[0];
            if (msj.includes('MUST EXCEED THE INITIAL MARGIN'))
              this.existemargenbroker = false;
            if (msj.includes('Exchange is closed'))
              this.brokerOpen = false;
            this.ordenPendiente = false;
            this.toastr.error(msj, 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
            console.log(data.error);
            this.guardarNotificacion(new Notificacion('Margen broker excedido ', msj, 'BROKER - ' + this.BrokoptimalWallet.nombre));
          }

        }, error: (error) => {
          console.log("entre en NOTIFICAR CIERRE");
          let msj = '';
          msj = error.statusText;
          //          msj += ' - ' + error.error;

          // Resultado desconocido (timeout, corte): la orden pudo llegar a IBKR, no se reintenta.
          quitarOrden();
          const ticker = ordersData.orders[0]?.ticker ?? ordersData.orders[0]?.cOID;
          const aviso = `No se pudo confirmar la orden de ${ticker} (${msj || 'sin respuesta'}). No se reintentará: revise en IBKR si se ejecutó.`;
          this.toastr.error(aviso, 'Orden sin confirmar', { timeOut: 0, closeButton: true, positionClass: 'toast-top-center' });
          this.guardarNotificacion(new Notificacion('Orden IBKR sin confirmar', aviso, 'BROKER - ' + this.BrokoptimalWallet.nombre));

          var data = [{ order_status: msj, local_order_id: ordersData.orders[0].cOID }];
          this._sseservice.apiPostNew('broker/actualizarOrdenRechazada', data, this.licencia).subscribe({
            next: (data: any) => {
              if (data.status) {
                this._brokerService.updatecargarListas(true);
                this.ordenPendiente = false;
              }
            }
          });
        }
      });
  }

  notificarCierre() {
    console.log("entre en NOTIFICAR CIERRE");
    this._cookieService.delete('auth_broker');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: 'Se ha Cerrado la Sesion Por el Broker'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        this._cookieService.delete('auth_broker');
        this.router.navigate(['/broker']);
        this.ngOnDestroy();
        this.inicializarData();
        this.inicializarBroker();
        //this.router.navigate(['/broker']);
      } else {
        this.router.navigate(['/broker']);
      }
    });

  }

  DataBroker() {
    // --- MetaAPI path ---
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);
      this.brokerAdapterFactory.getAdapter(this.BrokoptimalWallet)
        .getAccountSummary(accountId).subscribe({
          next: (wallet: Broker) => {
            this.walletBroker.PoderAdquisitivo = Number(wallet.PoderAdquisitivo).toFixed(2) as any;
            this.walletBroker.ValorLiquidativo  = Number(wallet.ValorLiquidativo).toFixed(2) as any;
            this.walletBroker.MargenTotal       = Number(wallet.MargenTotal).toFixed(2) as any;
            this.walletBroker.FondosDisponible  = Number(wallet.FondosDisponible).toFixed(2) as any;
            this.walletBroker.Efectivo          = Number(wallet.Efectivo).toFixed(2) as any;
            this.efectivopositivobroker = Number(wallet.Efectivo) > 0;
            const nlv    = Number(wallet.ValorLiquidativo);
            const margin = Number(wallet.MargenTotal);
            this.existemargenbroker = nlv > 0
              ? margin < nlv * (this.BrokoptimalWallet.controlMarginCall / 100)
              : true;
          },
          error: (err: any) => {
            // Fallo pasajero (5xx, red, 429): se mantienen los saldos anteriores sin avisar
            if (err?.metaApiTransient) {
              console.warn('[MetaAPI] accountInformation no respondió; se mantienen los saldos anteriores', err);
              return;
            }
            const motivo = err?.message ?? 'Error desconocido';
            const esTerminalDesconectado = err?.metaApiTerminalError ||
              (typeof motivo === 'string' && motivo.toLowerCase().includes('callable'));
            const mensaje = esTerminalDesconectado
              ? 'La terminal MetaTrader no está conectada al broker. Verifique que el terminal MT4/MT5 esté activo y que la cuenta esté desplegada en MetaAPI.'
              : `Error al obtener datos de la cuenta MetaAPI: ${motivo}`;
            this.toastr.error(mensaje, 'Terminal desconectada', {
              timeOut: 0, closeButton: true, positionClass: 'toast-top-center'
            });
          }
        });
      return;
    }

    // --- IBKR path (unchanged) ---
    let url = '/portfolio/' + this.BrokoptimalWallet.nombre + '/summary';
    this.oauthService.apiGetIbrk(url).subscribe({
      next: (data: any) => {
        console.log(data);
        if (data.buyingpower) {
          this.walletBroker.PoderAdquisitivo = (data.buyingpower.amount).toFixed(2);
        }
        if (data.netliquidation) {
          this.walletBroker.ValorLiquidativo = (data.netliquidation.amount).toFixed(2);
        }
        if (data.fullmaintmarginreq) {
          this.walletBroker.MargenTotal = (data.fullinitmarginreq.amount).toFixed(2);
        }
        if (data.availablefunds) {
          this.walletBroker.FondosDisponible = (data.availablefunds.amount).toFixed(2);
        }
        if (data.accruedcash) {
          this.walletBroker.Efectivo = (data.totalcashvalue.amount).toFixed(2);
          this.efectivopositivobroker = this.walletBroker.Efectivo > 0;
        }
        if (data.fullinitmarginreq.amount < (data.netliquidation.amount * (this.BrokoptimalWallet.controlMarginCall / 100))) {
          this.existemargenbroker = true;
        } else {
          this.existemargenbroker = false;
        }
      }
    });
  }

  checkearStatus() {
    // Si la cartera aún no se cargó pero hay credenciales MetaAPI en localStorage, no llamar IBKR
    if (!this.BrokoptimalWallet?.tipoBroker && localStorage.getItem('metaapi_token')) return;

    // --- MetaAPI path ---
    if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
      const accountId = this.brokerAdapterFactory.getAccountId(this.BrokoptimalWallet);
      this.metaApiService.verifyConnection(accountId, ACC_INFO_TTL_BROKER_MS).subscribe({
        next: (ok: boolean) => {
          const wasLoggedIn = this.isLoggin;
          this.isLoggin = ok;
          this.textButton = ok ? 'Conectados MetaAPI' : 'Desconectados MetaAPI';
          if (!ok) {
            this._cookieService.delete('auth_broker');
          } else if (!wasLoggedIn && ok) {
            // Transition: disconnected → connected. Re-trigger the same
            // initialization events that fire when a wallet is first loaded.
            this._brokerService.iniciadoTiempoReal = false;
            this._brokerService.revisadosuscrito = false;
            this._brokerService.updateBrokOptimaWallet(this.BrokoptimalWallet);
          }
        },
        error: () => {
          this.isLoggin = false;
          this.textButton = 'Desconectados MetaAPI';
          this._cookieService.delete('auth_broker');
        }
      });
      return;
    }

    // --- IBKR path (unchanged) ---
    this.oauthService.apiGetIbrk(this.url).subscribe({
      next: (data: any) => {
        this.responseData = data;
        if (this.responseData) {
          if (this.responseData.competing === true) {
            if (!this.competingSessionWarned) {
              this.toastr.error('La sesión de IBKR está siendo utilizada en otro dispositivo o pestaña.', 'Broker', { timeOut: 6000 });
              this.competingSessionWarned = true;
            }
            this.textButton = "Desconectados Broker";
            this.isLoggin = false;
            this._cookieService.delete('auth_broker');
          } else if (this.responseData.authenticated === true && this.responseData.connected == true) {
            this.competingSessionWarned = false;
            this.textButton = "Conectados Broker";
            this.isLoggin = true;
          } else {
            this.competingSessionWarned = false;
            this.textButton = "Desconectados Broker";
            this.isLoggin = false;
            this._cookieService.delete('auth_broker');
          }
        } else {
          this.textButton = "Desconectados Broker";
          this.isLoggin = false;
          this._cookieService.delete('auth_broker');
        }
      }, error: (err) => {
        this.textButton = "Desconectados Broker";
        this._brokerService.updateBrokcompaniaMercado([]);
        this.isLoggin = false;
        this._cookieService.delete('auth_broker');
      }
    });
  }

  botonSesion() {
    console.log("ENTRO AUI EN CERRAR SESION");
    let url = '/logout';
    if (this.isLoggin) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'Esta Seguro de Cerrar Sesion en Broker? \n Debera volver a ingresar sus credenciales.'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró');
        if (result) {
          if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
            this.metaApiService.clearCredentials();
            this.textButton = 'Desconectados MetaAPI';
            this.isLoggin = false;
            this.inicializarData();
            this.inicializarBroker();
            this._brokerService.updateBrokcompaniaMercado([]);
            return;
          }
          this.oauthService.apiGetIbrk(url).subscribe({
            next: (data: any) => {
              if (data.status) {
                this._cookieService.delete('auth_broker');
                this._cookieService.delete('liveSessionToken');
                this._cookieService.delete('accessToken');
                this._cookieService.delete('diffieHellmanChallenge');
                this._cookieService.delete('oauthToken');
                this._cookieService.delete('oauthVerifier');
                this._cookieService.delete('prepend');
                this._cookieService.delete('tokenSecret');
                this.router.navigate(['/broker']);
                this.textButton = 'Desconectados Broker';
                this.isLoggin = false;
                //this.ngOnDestroy();
                this.inicializarData();
                this.inicializarBroker();
                this._brokerService.updateBrokcompaniaMercado([]);
              }
            }
          });

        } else {
          // Lógica a ejecutar si se cancela la acción
          console.log('La acción fue cancelada');
        }
      });
    } else {
      if (this.BrokoptimalWallet?.tipoBroker === 'METAAPI') {
        localStorage.setItem('iboauthmethod', '2');
      }
      this.abrirDialogoInicioSesion()
    }


  }
  inicializarBroker() {
    this.walletBroker = this.defaultBroker;
    this.walletBroker.PoderAdquisitivo = 0;
    this.walletBroker.ValorLiquidativo = 0;
    this.walletBroker.MargenTotal = 0;
    this.walletBroker.FondosDisponible = 0;
    this.walletBroker.Efectivo = 0;
    this.BrokoptimalWallet = this._brokerService.getDefaultWallet();
    this._brokerService.updateBrokOptimaWallet(this.BrokoptimalWallet);

  }

  abrirDialogoInicioSesion(cuentaAutoseleccionar?: string, soloLoginMetaApi: boolean = false) {
    // Un único login a la vez: los temporizadores y suscripciones pueden pedirlo repetidamente
    if (this.dialog.openDialogs.some(d => d.componentInstance instanceof LoginDialogComponent)) {
      return;
    }
    console.log("abriendo sesion ");
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(LoginDialogComponent, {
      width: '800px', // Ancho del diálogo
      maxHeight: '600px', // Alto máximo del diálogo (se ajusta al contenido)
      panelClass: dialogClass, data: {
        modo: this.modo,
        cuenta: cuentaAutoseleccionar,
        metaApi: soloLoginMetaApi,
        soloLoginMetaApi
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialogo cerrado', result);
    });
  }


  confirmarOp(idmsg: any) {
    let url = '/iserver/reply/' + idmsg;
    //let urlApi = 'broker/actualizarOrden';
    console.log("esto es el url")
    let dataJson = { confirmed: true }
    let msj = '';

    this.oauthService.apiPostIbrk(url, dataJson).subscribe({
      next: (data: any) => {
        console.log("DATOS DESDE REPLY: ", data);
        if (data[0]) {
          if (data[0].message) {
            console.log("esta es la orden a confirmar: ", data[0].id)
            this.confirmarOp(data[0].id);
            this._brokerService.updatecargarListas(true);//darle una vuelta a      
          }
          if (data[0].order_status) {
            msj = 'Se registro Operacion:' + data[0].order_id + ' ' + data[0].order_status;
            if (data[0].order_status == 'Submitted' || data[0].order_status == 'PreSubmitted' || data[0].order_status == 'PendingSubmit' || data[0].order_status == 'Filled' || data[0].order_status == 'Cancelled' || data[0].order_status == 'Innactive') {//PreSubmitted, PendingSubmit, Filled, Cancelled

              this._sseservice.apiPostNew('broker/actualizarOrden', data, this.licencia).subscribe({
                next: (data: any) => {
                  if (data.status) {
                    this._brokerService.updatecargarListas(true);
                    this.ordenPendiente = false;
                  }
                }
              });

            }
          }
        }
        if (data.error) {
          msj = data.cqe.post_payload.rejections[0];
          if (msj.includes('MUST EXCEED THE INITIAL MARGIN'))
            this.existemargenbroker = false;
          if (msj.includes('Exchange is closed'))
            this.brokerOpen = false;
          this.toastr.error(msj, 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
          ;

          this.guardarNotificacion(new Notificacion('Margen broker excedido ', msj, 'broker'));
        }
        this.ordenPendiente = false;
      }, error: (error) => {
        console.log(error.error);
        this.ordenPendiente = false;
      }
    });
  }
  guardarNotificacion(notificacion: Notificacion) {
    notificacion.estado = true;
    console.log(notificacion);
    this.notificacionService.guardarNotificacion(notificacion).subscribe({
      next: (value) => {
        //this.cd.markForCheck();
      },
      error: (err) => {
        console.log("Ocurrió un error actualizando la notificación");
      },
    });
  }
  confirmar(openInNewTab: boolean = false) {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    this._brokerService.valBrokOp$.pipe(first()).subscribe(primerValor => {
      let desd = new Date();
      if (Array.isArray(primerValor) && primerValor.length > 0) {
        // Check if the first element is an array and has at least one element
        if (Array.isArray(primerValor[0]) && primerValor[0].length > 0) {
          // Now we can safely access primerValor[0][0]
          if (primerValor[0][0] && primerValor[0][0].fechaOperacion !== undefined) {
            desd = primerValor[0][0].fechaOperacion;
          }
        }
      }
      this.desdeDate = desd;
      const data: any = {
        idcartera: this.BrokoptimalWallet.idcartera,
        modulo: 'broker',
        cartera: this.BrokoptimalWallet.nombre,
        idcarterasuscrita: this.idcarterasuscrita,
        desde: desd,
        tipoBroker: this.BrokoptimalWallet.tipoBroker ?? 'IBKR',
        metaApiAccountId: this.BrokoptimalWallet.metaApiAccountId ?? ''
      };
      this._sseservice.apiGetNew('revisarSuscrito?nombre=' + encodeURIComponent(this.BrokoptimalWallet.nombre)).subscribe({
        next: (datat: any) => {
          if (datat.status === 'success') {
            this.suscrito = true;
            this.aplicarPeriodoSuscripcion(datat.periodosuscripcion, datat.periodos);
            if (openInNewTab) {
              const url = this.router.serializeUrl(
                this.router.createUrlTree(['/confirmar'], { queryParams: data })
              );
              window.open(url, '_blank');
            } else {
              // Open as a modal dialog
              this.dialog.open(SuscripcionesConfirmarComponent, {
                width: "100%",
                height: "70%",
                panelClass: dialogClass,
                data: datat
              });
            }
          } else {
            this.suscrito = false;
          }

        }
      });

    });
  }
  private getLastBusinessDayData(vlaData: any[]): any[] {
    // Última fecha en una pasada, sin ordenar: vlaData es el lote que muestra la tabla de valores
    // latentes (que ahora lo lee tras un auditTime) y ordenarlo en sitio le cambiaba el orden.
    // Mismo resultado que el sort estable descendente anterior.
    let ultima = vlaData[0];
    let ultimaMs = parseDateOrFallback(ultima.fechaintervalo).getTime();
    for (const item of vlaData) {
      const ms = parseDateOrFallback(item.fechaintervalo).getTime();
      if (ms > ultimaMs) { ultima = item; ultimaMs = ms; }
    }
    this.lastBusinessDay = ultima.fechaintervalo;
    return vlaData.filter(item => item.fechaintervalo === this.lastBusinessDay);
  }

  private updateIdnectumsArray() {
    // IDs de las posiciones de la cartera
    const carteraIdnectums = this.posicionesModel ? this.posicionesModel.map(posicion => posicion.idNectum) : [];

    // IDs de las primeras 30 compañías de la tabla de mercado (ya vienen del servicio)
    const mercadoIdnectums = this.mercadoIdnectumsArray || [];

    console.log('>>> BROKER updateIdnectumsArray - IDs cartera:', carteraIdnectums);
    console.log('>>> BROKER updateIdnectumsArray - IDs mercado:', mercadoIdnectums);

    // Combinar ambos arrays sin duplicados
    const combinedIds = [...new Set([...carteraIdnectums, ...mercadoIdnectums])];

    this.idnectumsArray = combinedIds.filter(id => id != null);

    console.log('>>> BROKER updateIdnectumsArray - IDs combinados:', this.idnectumsArray);

    // Solo reconectar si hay cambios en los IDs (se llama con cada lote 'vla' del recálculo)
    if (this.idnectumsArray.length > 0) {
      const ids = this.idnectumsArray.join(',');
      if (this.companiaWebsocketService.conectadoA(ids)) return;
      this.companiaWebsocketService.disconnect();
      console.log('>>> BROKER: Conectando socket con IDs:', ids);
      this.companiaWebsocketService.connect(ids);
    } else {
      console.log('>>> BROKER: No hay IDs para conectar al socket');
    }
  }

  showCarteraHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Cartera Óptima',
      items: [
        { term: 'Capital Inicial', description: 'El capital con el que se inicia la cartera.' },
        { term: 'Valor Liquidativo Neto', description: 'Valor actual de todos los activos de la cartera.' },
        { term: 'Efectivo', description: 'Dinero disponible para nuevas operaciones.' },
        { term: 'Tipo Cuenta', description: 'MARGEN (permite apalancamiento) o NOMINAL (sin apalancamiento).' },
        { term: 'Margen Requerido %', description: 'Porcentaje del capital requerido como garantía.' },
        { term: 'Control Margin Call %', description: 'Umbral de alerta para llamada de margen.' },
        { term: 'Riesgo Máximo %', description: 'Porcentaje máximo de capital que se puede arriesgar.' },
        { term: 'Tipo Riesgo', description: 'LIMITADO (según riesgo) o FIJO (cantidad fija).' },
        { term: 'Valor Riesgo', description: 'Valor monetario del riesgo por operación.' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  showRiesgoHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Configuración Riesgo',
      items: [
        { term: 'Riesgo Máximo %', description: 'Porcentaje máximo del capital que se puede arriesgar en todas las operaciones abiertas.' },
        { term: 'Tipo Riesgo', description: 'LIMITADO: el tamaño de posición se calcula según el riesgo. FIJO: cantidad fija por operación.' },
        { term: 'Valor Riesgo', description: 'Cantidad monetaria máxima a arriesgar por cada operación individual.' },
        { term: 'Comisión 2/2', description: 'Comisión del broker aplicada tanto a la entrada como a la salida de cada operación.' },
        { term: 'Gastos Gestión', description: 'Porcentaje de gastos de gestión aplicados sobre el capital.' },
        { term: 'Gastos Préstamo %', description: 'Intereses por préstamo de acciones en operaciones en corto (bajistas).' },
        { term: 'Comprar/Vender Fracciones', description: 'Permite comprar fracciones de acciones en lugar de unidades completas.' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  showAutomatizarHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Proceso de Automatización Broker',
      items: [
        { term: '1', description: 'Todos los calculos de los modelos se hacen con datos de api.... entradas. salidas. stoploss, profit, indicadores' },
        { term: '2', description: 'Solo en cartera/broker se mostrara el valor real de las posiciones con datos del broker' },
        { term: '3', description: 'En todos los estudios se da la opcion de aplicar comisiones y gastos de gestion para considerar en todo momento el slipagge de la operativa real.' },
        
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '550px',
      data: helpData
    });
  }

  showTabHelp(tab: string, event: Event): void {
    event.stopPropagation();
    const tabHelpData: { [key: string]: HelpDialogData } = {
      'gestion': {
        title: 'Ayuda - Gestión/Contabilidad',
        items: [
          { term: 'Resumen', description: 'Vista general del estado de la cartera con métricas principales.' },
          { term: 'Balance', description: 'Registro de movimientos de capital, depósitos y retiros.' },
          { term: 'Comisiones', description: 'Detalle de comisiones pagadas al broker por operaciones.' }
        ]
      },
      'operaciones': {
        title: 'Ayuda - Operaciones',
        items: [
          { term: 'Operaciones Abiertas', description: 'Posiciones actualmente en cartera con su rendimiento en tiempo real.' },
          { term: 'Histórico', description: 'Registro de todas las operaciones cerradas con sus resultados.' },
          { term: 'Filtros', description: 'Permite filtrar operaciones por fecha, tipo, activo, etc.' }
        ]
      },
      'valores': {
        title: 'Ayuda - Valores Liquidativos',
        items: [
          { term: 'VL Diario', description: 'Valor liquidativo neto de la cartera calculado al cierre de cada día.' },
          { term: 'Evolución', description: 'Gráfica de la evolución del valor de la cartera en el tiempo.' },
          { term: 'Drawdown', description: 'Máxima caída desde el punto más alto de la curva de capital.' }
        ]
      },
      'rendimientos': {
        title: 'Ayuda - Rendimientos/Riesgos',
        items: [
          { term: 'Rentabilidad', description: 'Porcentaje de ganancia o pérdida sobre el capital inicial.' },
          { term: 'Sharpe Ratio', description: 'Mide el rendimiento ajustado al riesgo de la cartera.' },
          { term: 'Volatilidad', description: 'Desviación estándar de los rendimientos, indica el riesgo.' },
          { term: 'Max Drawdown', description: 'Máxima pérdida porcentual desde un máximo histórico.' }
        ]
      },
      'cartera': {
        title: 'Ayuda - Cartera',
        items: [
          { term: 'Posiciones', description: 'Lista de activos en cartera con cantidad, precio y valor actual.' },
          { term: 'Ponderación', description: 'Porcentaje que representa cada activo del total de la cartera.' },
          { term: 'P&L', description: 'Ganancia o pérdida (Profit & Loss) de cada posición.' }
        ]
      }
    };
    const helpData = tabHelpData[tab];
    if (helpData) {
      this.dialog.open(HelpDialogComponent, {
        width: '450px',
        data: helpData
      });
    }
  }
  faseLabel(fase: MetaApiDownloadFase | ''): string {
    switch (fase) {
      case 'hueco': return 'rellenando hueco interno';
      case 'cola-antigua': return 'completando historial antiguo';
      case 'reciente': return 'actualizando datos recientes';
      case 'inicial': return 'descarga inicial';
      default: return '';
    }
  }

  private getPeriodoTimeframe(periodoId: number): string | null {
    return periodoToTimeframe(periodoId) ?? null;
  }

  /**
   * Velas que necesita la revisión del modelo: solo los timeframes de la cartera.
   * El diario no interviene en la revisión de un modelo intradía (el backend carga únicamente la
   * serie del periodo del modelo) y su vela no se cierra hasta el final del día, así que se
   * sincroniza al forzar entradas y una vez por día del broker, no en cada cierre intradía.
   */
  private async actualizarCandlesAntesDeRevisarModelo(manual: boolean): Promise<ResultadoDescargaVelas> {
    if (this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') {
      return { ok: true, idNectumSinVelas: [], avisos: [] };
    }

    const requeridos = this.timeframesCartera();
    const timeframes = new Set(requeridos);

    const diaBroker = this.diaBrokerActual();
    const incluirDiario = manual || this.ultimoDiaSyncDiario !== diaBroker;
    if (incluirDiario) timeframes.add('1d');

    if (timeframes.size === 0) {
      return { ok: true, idNectumSinVelas: [], avisos: [] };
    }

    // Solo las últimas barras: huecos antiguos y cola antigua no deben retrasar la señal del
    // cierre; se completan después con sincronizarCompletaTrasRevision.
    const resultado = await this.descargarCandlesMetaapi(Array.from(timeframes), undefined, manual, 'revision', requeridos);
    if (resultado.ok && incluirDiario) this.ultimoDiaSyncDiario = diaBroker;
    return resultado;
  }

  /** Timeframes de los modelos de la cartera: los que evalúa revisarModeloBrokerIajava. */
  private timeframesCartera(): string[] {
    const periodos = this.periodosCarteraActual.length > 0
      ? this.periodosCarteraActual
      : [String(this.periodoSuscripcionId)];
    return Array.from(new Set(
      periodos.map(p => this.getPeriodoTimeframe(Number(p))).filter((tf): tf is string => !!tf)
    ));
  }

  /**
   * Huecos internos y cola antigua, fuera del camino crítico de la revisión: una vez por día del
   * broker o tras forzar entradas. Si llega otro cierre mientras corre, la descarga de la revisión
   * la cancela; se reanuda sola en la siguiente pasada porque tieneCandles vuelve a detectar lo
   * que falte.
   */
  private sincronizarCompletaTrasRevision(manual: boolean): void {
    if (this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') return;
    const diaBroker = this.diaBrokerActual();
    if (!manual && this.ultimoDiaSyncCompleta === diaBroker) return;
    // El 1d entra siempre: en modo revisión un fallo del diario no bloquea ni se reintenta.
    const timeframes = Array.from(new Set([...this.timeframesCartera(), '1d']));
    void this.descargarCandlesMetaapi(timeframes, undefined, false, 'completa').then(r => {
      if (r.ok) this.ultimoDiaSyncCompleta = diaBroker;
    });
  }

  /**
   * Cierre de periodo con la automatización apagada: solo sincroniza velas (sin revisar el modelo).
   * Sin token MetaAPI no hace nada, para no avisar ni abrir el login en cada periodo.
   */
  private async sincronizarVelasSinRevision(): Promise<void> {
    if (this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') return;
    if (!this.metaApiService.hasToken()) return;
    // Sin modelo suscrito el periodo es 0: el contador va cada 32 s y timeframesCartera() cae en 1d.
    if (!this.tieneModeloSuscrito()) return;
    if (this.actualizandoTiempoReal || this.isLoadingMetaapi) return;
    const timeframes = new Set(this.timeframesCartera());
    const diaBroker = this.diaBrokerActual();
    const incluirDiario = this.ultimoDiaSyncDiario !== diaBroker;
    if (incluirDiario) timeframes.add('1d');
    if (timeframes.size === 0) return;
    const r = await this.descargarCandlesMetaapi(Array.from(timeframes), undefined, false, 'completa');
    if (r.ok && incluirDiario) this.ultimoDiaSyncDiario = diaBroker;
  }

  /**
   * Al abrir el multichart: últimas barras de los timeframes de la cartera, para no dejar un hueco
   * entre la BD y la vela en vivo hasta el siguiente cierre. No toca el contador ni la revisión.
   */
  private async sincronizarVelasAlAbrirGrafica(): Promise<void> {
    if (this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') return;
    if (!this.metaApiService.hasToken() || !this.isLoggin) return;
    if (!this.tieneModeloSuscrito()) return;
    // Una revisión o descarga en curso ya notificará velasSincronizadas$ al terminar.
    if (this.actualizandoTiempoReal || this.isLoadingMetaapi) return;
    const timeframes = this.timeframesCartera();
    if (timeframes.length === 0) return;
    await this.descargarCandlesMetaapi(timeframes, undefined, false, 'revision');
  }

  private tieneModeloSuscrito(): boolean {
    return this.suscrito && this.periodoSuscripcionId !== 0;
  }

  /** Fecha del día en la zona del broker (o del navegador si aún no se conoce el offset). */
  private diaBrokerActual(): string {
    return this.brokerTimeService.formatDate(new Date(), this.brokerOffsetMin);
  }

  /** Una tarea por par activo-timeframe: dos modelos con el mismo activo y periodo comparten descarga. */
  private construirTareasDescarga(companias: any[], timeframes: string[]): Array<{ compania: any; timeframe: string }> {
    const vistas = new Set<string>();
    const tareas: Array<{ compania: any; timeframe: string }> = [];
    for (const timeframe of timeframes) {
      for (const compania of companias || []) {
        if (compania?.idNectum == null) continue;
        const clave = `${compania.idNectum}|${timeframe}`;
        if (vistas.has(clave)) continue;
        vistas.add(clave);
        tareas.push({ compania, timeframe });
      }
    }
    return tareas;
  }

  /**
   * Sincroniza en una sola pasada todas las tareas activo × timeframe: una comprobación de
   * credenciales, un único indicador de descarga y cada par descargado una sola vez.
   * Con `interactivo` a false (revisión automática) no abre el login si faltan credenciales.
   *
   * Modo `revision`: solo las últimas barras de cada par. Un par de `requeridos` que falle o no
   * llegue a las barras mínimas bloquea las entradas de su activo, sin parar el resto. Si hay una
   * descarga `completa` en curso, se cancela para no retrasar la revisión.
   * Modo `completa`: huecos, cola antigua y tramo reciente; cualquier fallo deja `ok` a false.
   */
  private async descargarCandlesMetaapi(
    timeframes: string[],
    companiasOverride?: any[],
    interactivo: boolean = true,
    modo: 'revision' | 'completa' = 'completa',
    requeridos: string[] = timeframes
  ): Promise<ResultadoDescargaVelas> {
    const fallo: ResultadoDescargaVelas = { ok: false, idNectumSinVelas: [], avisos: [] };
    if (this.BrokoptimalWallet?.tipoBroker !== 'METAAPI') {
      return { ok: true, idNectumSinVelas: [], avisos: [] };
    }

    if (this.isLoadingMetaapi) {
      if (modo !== 'revision' || !this.cancelarDescargaCompleta) return fallo;
      this.cancelarDescargaCompleta();
    }

    // Sin pasar a minúsculas: el id de las cuentas del gateway MT5 lleva el servidor con mayúsculas
    const metaapiAccount = this.BrokoptimalWallet.metaApiAccountId
      ?? localStorage.getItem('metaapi_account_id')
      ?? this.BrokoptimalWallet.nombre
      ?? '';

    if (!metaapiAccount) {
      return fallo;
    }

    return new Promise<ResultadoDescargaVelas>((resolve) => {
      this.metaApiService.canDownloadCandles(metaapiAccount).subscribe({
        next: (guard) => {
          if (!guard.ok) {
            this.toastr.error(guard.message, guard.title, { timeOut: 5000 });
            if (interactivo) {
              this.abrirDialogoInicioSesion(guard.accountId || metaapiAccount, true);
            }
            resolve(fallo);
            return;
          }

          const accountId = guard.accountId;
          let hadError = false;
          const marcarError = () => {
            hadError = true;
            return EMPTY;
          };
          const sinVelas = new Set<number>();
          const avisos: string[] = [];
          const bloquear = (compania: any, timeframe: string, motivo: string) => {
            if (!requeridos.includes(timeframe)) return;
            sinVelas.add(Number(compania.idNectum));
            avisos.push(`${compania.iso} ${timeframe}: ${motivo}`);
          };
          const resultado = (): ResultadoDescargaVelas =>
            ({ ok: !hadError, idNectumSinVelas: Array.from(sinVelas), avisos });

          const ejecutarDescarga = (companias: any[]) => {
            const tareas = this.construirTareasDescarga(companias, timeframes);
            if (tareas.length === 0) {
              resolve(resultado());
              return;
            }

            this.isLoadingMetaapi = true;
            const onBatch = (batch: number, total: number) => {
              this.candlesDownloadBatch = batch;
              this.candlesDownloadTotal = total;
            };
            const onTotal = (expected: number) => { this.candlesDownloadExpected = expected; };
            const onFase = (fase: MetaApiDownloadFase) => { this.candlesDownloadFase = fase; };

            // Retraso del feed por activo: se mide una vez y vale para todos sus timeframes.
            const retrasos = new Map<number, Observable<number | null>>();
            const retraso$ = (compania: any) => {
              const clave = Number(compania.idNectum);
              if (!retrasos.has(clave)) {
                retrasos.set(clave, this.medirRetrasoMin(accountId, compania.iso).pipe(shareReplay(1)));
              }
              return retrasos.get(clave)!;
            };

            const tarea$ = (compania: any, timeframe: string) => modo === 'revision'
              ? this.sincronizarUltimasBarrasTarea(compania, timeframe, accountId, onBatch, onFase).pipe(
                  tap(cerradas => {
                    if (cerradas < BrokerComponent.BARRAS_MINIMAS_REVISION) {
                      bloquear(compania, timeframe, `solo ${cerradas} de ${BrokerComponent.BARRAS_MINIMAS_REVISION} barras`);
                    }
                  }),
                  concatMap(() => requeridos.includes(timeframe) ? retraso$(compania) : of(null)),
                  tap(retraso => {
                    if (retraso != null && retraso >= BrokerComponent.RETRASO_MAX_MIN) {
                      bloquear(compania, timeframe, `datos con ~${Math.round(retraso)} min de retraso`);
                    }
                  }),
                  catchError(err => {
                    console.error(`[MetaAPI] Últimas barras no descargadas (${compania.iso} ${timeframe})`, err);
                    bloquear(compania, timeframe, `error de descarga (${this.describirErrorDescarga(err)})`);
                    return EMPTY;
                  })
                )
              : this.sincronizarCandlesTarea(compania, timeframe, accountId, onBatch, onTotal, onFase, marcarError);

            const sub = from(tareas).pipe(
              concatMap(({ compania, timeframe }) => {
                this.candlesDownloadSymbol = `${compania.iso} ${timeframe}`;
                this.candlesDownloadBatch = 0;
                this.candlesDownloadTotal = 0;
                this.candlesDownloadExpected = 0;
                this.candlesDownloadFase = '';
                return timer(100).pipe(concatMap(() => tarea$(compania, timeframe)));
              }),
              catchError(marcarError)
            ).subscribe({
              complete: () => {
                this.isLoadingMetaapi = false;
                if (modo === 'completa') this.cancelarDescargaCompleta = null;
                if (!hadError) this.metaapiCandlesSyncService.notificarVelasSincronizadas();
                resolve(resultado());
              },
              error: () => {
                this.isLoadingMetaapi = false;
                if (modo === 'completa') this.cancelarDescargaCompleta = null;
                resolve(fallo);
              }
            });

            if (modo === 'completa') {
              this.cancelarDescargaCompleta = () => {
                sub.unsubscribe();
                this.isLoadingMetaapi = false;
                this.cancelarDescargaCompleta = null;
                console.log('[MetaAPI] Sincronización completa cancelada por la revisión del cierre');
                resolve(fallo);
              };
            }
          };

          if (companiasOverride) {
            ejecutarDescarga(companiasOverride);
            return;
          }

          if (!this.carterasmetaapi || this.carterasmetaapi.length === 0) {
            this._sseservice.apiPostNew('broker/obtenercarterassuscripcion', { idcartera: this.BrokoptimalWallet.idcartera }, this.licencia).subscribe({
              next: (carterasResp: any) => {
                this.carterasmetaapi = carterasResp?.isos ?? [];
                this.syncCarteraStream();
                ejecutarDescarga(this.carterasmetaapi);
              },
              error: () => resolve(fallo)
            });
            return;
          }

          ejecutarDescarga(this.carterasmetaapi);
        },
        error: () => resolve(fallo)
      });
    });
  }

  /**
   * Minutos que lleva de retraso el feed del símbolo: inicio de la última vela de 1m que sirve
   * MetaAPI frente al reloj local (la cabecera Date no es legible por CORS). Se mide en 1m sea cual
   * sea el timeframe del modelo, porque en periodos largos la última vela puede ser legítimamente
   * antigua. MetaAPI no marca los feeds delayed, así que es la única forma de detectarlos.
   * null si no hay velas o son tan antiguas que el mercado está cerrado.
   */
  /** Causa corta de un fallo de descarga para el aviso de velas: la consola no la ve el usuario. */
  private describirErrorDescarga(err: any): string {
    if (err?.status === undefined) return String(err?.message ?? 'error desconocido').slice(0, 80);
    const origen = String(err.url ?? '').startsWith(global.url) ? 'servidor' : 'bróker';
    if (err.status === 0) return `${origen} sin respuesta`;
    const cuerpo = err.error?.message ?? err.error?.error;
    return `${origen} HTTP ${err.status}${cuerpo ? ': ' + String(cuerpo).slice(0, 80) : ''}`;
  }

  private medirRetrasoMin(accountId: string, symbol: string): Observable<number | null> {
    return this.metaApiService.getLatestCandles(accountId, symbol, '1m', 2).pipe(
      map((candles: any[]) => {
        const ultima = candles[candles.length - 1];
        const time = ultima?.time ? new Date(ultima.time).getTime() : NaN;
        if (isNaN(time)) return null;
        // La vela empieza un minuto antes de cerrarse: se descuenta para no contarlo como retraso.
        const retraso = Math.max(0, (Date.now() - time) / 60000 - 1);
        return retraso > BrokerComponent.RETRASO_MERCADO_CERRADO_MIN ? null : retraso;
      }),
      catchError(() => of(null))
    );
  }

  /**
   * Garantiza las últimas barras de un activo antes de revisar el modelo y devuelve cuántas
   * cerradas se han recibido de MetaAPI. Un activo sin datos también entra por aquí (solo la
   * ventana reciente): su cola antigua la completa después la sincronización completa.
   */
  private sincronizarUltimasBarrasTarea(
    compania: any,
    timeframe: string,
    accountId: string,
    onBatch: (batch: number, total: number) => void,
    onFase: (fase: MetaApiDownloadFase) => void
  ): Observable<number> {
    return this._sseservice.apiPostNew('metaapi/tieneCandles', { idNectum: compania.idNectum, timeframe, accountId }, this.licencia).pipe(
      concatMap((res: any) => {
        onFase(res.tieneCandles ? 'reciente' : 'inicial');
        const spec$: Observable<any> = res.tieneCandles
          ? of(null)
          : this.metaApiService.getSymbolSpecification(accountId, compania.iso).pipe(
              map((spec: any) => {
                if (!spec) throw new Error('Sin especificación del símbolo');
                if (this.specsMetaApiCuenta === accountId) this.specsMetaApi.set(String(compania.iso).toUpperCase(), spec);
                return spec;
              })
            );
        return spec$.pipe(concatMap(spec => {
          let lote = 0;
          let recibidas = 0;
          const velas$ = this.metaApiService.downloadUltimasBarras(
            accountId, compania.iso, timeframe, res.tieneCandles ? res.ultimaFecha : undefined, BrokerComponent.BARRAS_MINIMAS_REVISION
          ).pipe(
            concatMap((candles: any[]) => {
              const body: any = { candles, symbol: compania.iso, timeframe, idNectum: compania.idNectum };
              if (spec?.contractSize != null) body.contractSize = spec.contractSize;
              return this._sseservice.apiPostNew('metaapi/candles', body, this.licencia).pipe(
                map(() => candles.filter(c => c?.state !== 'intermediate').length)
              );
            }),
            tap(cerradas => { lote++; recibidas += cerradas; onBatch(lote, recibidas); }),
            reduce((total, cerradas) => total + cerradas, 0)
          );
          if (!spec) return velas$;
          return velas$.pipe(
            concatMap(total => this._sseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: 'METAAPI' }, this.licencia).pipe(
              map(() => total)
            ))
          );
        }));
      })
    );
  }

  /** Completa lo que falte de un activo en un timeframe (descarga inicial o huecos + tramo reciente). */
  private sincronizarCandlesTarea(
    compania: any,
    timeframe: string,
    accountId: string,
    onBatch: (batch: number, total: number) => void,
    onTotal: (expected: number) => void,
    onFase: (fase: MetaApiDownloadFase) => void,
    marcarError: () => typeof EMPTY
  ) {
    // Notifies the backend once MetaApi confirms it has no data before a given date, so
    // future syncs stop re-requesting the same empty range (see metaapi/historiaAgotada).
    const onExhausted = (fechaConfirmada: string) => {
      this._sseservice.apiPostNew('metaapi/historiaAgotada', { idNectum: compania.idNectum, timeframe, fechaConfirmada }, this.licencia).subscribe({
        error: (err) => console.error(`[MetaAPI] Error marcando historia agotada (${compania.iso} ${timeframe})`, err)
      });
    };
    // Notifies the backend once a gap-fill pass finds nothing at the source for an
    // internal hole, so future syncs stop reporting/retrying that exact hueco.
    const onHuecoExhausted = (huecoInferior: string, huecoSuperior: string) => {
      this._sseservice.apiPostNew('metaapi/huecoConfirmado', { idNectum: compania.idNectum, timeframe, huecoInferior, huecoSuperior }, this.licencia).subscribe({
        error: (err) => console.error(`[MetaAPI] Error marcando hueco confirmado (${compania.iso} ${timeframe})`, err)
      });
    };

    return this._sseservice.apiPostNew('metaapi/tieneCandles', { idNectum: compania.idNectum, timeframe, accountId }, this.licencia).pipe(
      concatMap((res: any) => {
        if (res.tieneCandles) {
          // downloadMissingCandles resumes any pending gap (internal hole, incomplete
          // old-tail backfill, or the normal recent-tail gap) — self-healing across
          // interrupted downloads.
          return this.metaApiService.downloadMissingCandles(accountId, compania.iso, timeframe, res, onBatch, onTotal, onFase, onExhausted, onHuecoExhausted).pipe(
            concatMap((candles: any[]) => {
              if (!candles || candles.length === 0) return EMPTY;
              return this._sseservice.apiPostNew('metaapi/candles', { candles, symbol: compania.iso, timeframe, idNectum: compania.idNectum }, this.licencia);
            }),
            catchError(marcarError)
          );
        }

        onFase('inicial');
        return this.metaApiService.getSymbolSpecification(accountId, compania.iso).pipe(
          concatMap((spec: any) => {
            if (!spec) return marcarError();
            const fromDate = MetaApiService.historicalFromDate(timeframe);
            return from([
              this.metaApiService.getCandlesHistorical(accountId, compania.iso, timeframe, fromDate, undefined, undefined, onBatch, onTotal, onExhausted).pipe(
                concatMap((batchCandles: any[]) =>
                  this._sseservice.apiPostNew('metaapi/candles', { candles: batchCandles, symbol: compania.iso, timeframe, idNectum: compania.idNectum, contractSize: spec.contractSize }, this.licencia)
                ),
                catchError(marcarError)
              ),
              this._sseservice.apiPostNew('metaapi/specificationes', { ...spec, tipoBroker: 'METAAPI' }, this.licencia).pipe(
                catchError(marcarError)
              )
            ]).pipe(concatMap(obs$ => obs$));
          }),
          catchError(marcarError)
        );
      }),
      catchError(marcarError)
    );
  }

}